import { Money } from '@phosphor-icons/react'
import 'chart.js/auto'
import { Link } from 'phosphor-react'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  Form,
  FormControl,
  InputGroup,
  Modal,
  OverlayTrigger,
  Row,
  Spinner,
  Tab,
  Table,
  Tabs,
  Tooltip,
} from 'react-bootstrap'
import {
  ArrowRepeat,
  Ban,
  Check2Circle,
  Copy,
  EyeFill,
  Globe,
  Pause,
  PauseBtnFill,
  Pencil,
  Search,
  Trash,
} from 'react-bootstrap-icons'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import { Doughnut } from 'react-chartjs-2'
import {
  FaCogs,
  FaCubes,
  FaExclamationCircle,
  FaInfoCircle,
  FaPause,
  FaPlus,
  FaStarHalfAlt,
  FaTruck,
  FaWrench,
} from 'react-icons/fa'
import ReactPaginate from 'react-paginate'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import Swal from 'sweetalert2'
import { CustomButton } from '../../components/CustomButton'
import { CustomIntegerInput } from '../../components/CustomDecimalInput'
import { CustomPriceInput } from '../../components/CustomPriceInput'
import { CustomSpinner } from '../../components/CustomSpinner'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { adaptValue } from '../../utils/adaptValue'
import { formatPrice } from '../../utils/formatPrice'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import './anuncios.css'
import { ModalReplicarResults } from './ModalReplicarResults'
import { ModalReplicarResultsBatch } from './ModalReplicarResultsBatch'

function Anuncios() {
  const [anunciosMl, setAnunciosMl] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const [pesquisa, setPesquisa] = useState(null)
  const [conta, setContas] = useState([])
  const [contaSelecionada, setContaSelecionada] = useState(null)
  const [selectedStatus, setSelectedStatus] = React.useState(statusMap[0]) // Estado para armazenar o status selecionado
  const [seller, setSeller] = useState('')
  const [mlb, setMlb] = useState('')
  const [tipo, setTipo] = useState('mlb')
  const [searchVariacao, setSearchVariacao] = useState('')
  const [searchComposicao, setSearchComposicao] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [showModalVariante, setShowModalVariante] = useState(false)
  const [newStock, setNewStock] = useState('')
  const [newStockVariante, setNewStockVariante] = useState('')
  const [isLoading, setLoading] = useState(true)
  const [isLoadingSearch, setIsLoadingSearch] = useState(false)
  const [isLoadingSearchComposicao, setIsLoadingSearchComposicao] =
    useState(false)
  const [produtoNome, setProdutonome] = useState('')
  const [selectedRows, setSelectedRows] = useState([])

  const [selectedAnuncio, setSelectedAnuncio] = useState({})
  const [selectedIdVariacao, setSelectedIdVariacao] = useState('')
  const [isVariantsLoading, setIsVariantsLoading] = useState({})
  const [isPausedLoading, setIsPausedLoading] = useState({})
  const [isQuantityVariantLoading, setIsQuantityVariantLoading] =
    useState(false)

  const [showModalSku, setShowModalSku] = useState(false)
  const [showModalPrice, setShowModalPrice] = useState(false)
  const [showModalSkuVariant, setShowModalSkuVariant] = useState(false)
  const [anuncioSku, setAnuncioSku] = useState('')
  const [variantPrice, setVariantPrice] = useState('')
  const [anuncioSkuVariant, setAnuncioSkuVariant] = useState('')
  const [isSkuAnuncioLoading, setIsSkuAnuncioLoading] = useState(false)
  const [isVariantPriceLoading, setIsVariantPriceLoading] = useState(false)
  const [isSkuVarianteLoading, setIsSkuVarianteLoading] = useState(false)
  const [isNoSkuAnunciosLoading, setIsNoSkuAnunciosLoading] = useState(false)
  const [selectedCodigoMk, setSelectedCodigoMk] = useState('')
  const [selectedVariantsIds, setSelectedVariantsIds] = useState([])
  const [isSelectedVariantsLoading, setIsSelectedVariantsLoading] =
    useState(false)
  const [isGenerateEANLoding, setIsGenerateEANLoading] = useState({})
  const [filteredVariantes, setFilteredVariantes] = useState([])
  const [isDeleteAnuncioLoading, setIsDeleteAnuncioLoading] = useState({})
  const [isModalAjustesMassaOpen, setIsModalAjustesMassaOpen] = useState(false)

  // Replicar
  const [showModalReplicar, setShowModalReplicar] = useState(false)
  const [contaReplicar, setContaReplicar] = useState('')
  const [selectedContasReplicar, setSelectedContasReplicar] = useState([])
  const [showModalShopee, setShowModalShopee] = useState(false)
  const [contasShopee, setContasShopee] = useState([])
  const [contaShopeeSelected, setContaShopeeSelected] = useState('')
  const [isLoadingShopeeContas, setIsLoadingShopeeContas] = useState(false)
  const [isLoadingEnvio, setIsloadingEnvio] = useState(false)
  const [selectedAnuncioForShopee, setSelectedAnuncioForShopee] = useState(null)

  const [showModalMagalu, setShowModalMagalu] = useState(false)
  const [contasMagalu, setContasMagalu] = useState([])
  const [contaMagaluSelected, setContaMagaluSelected] = useState('')
  const [isLoadingMagaluContas, setIsLoadingMagaluContas] = useState(false)
  const [isLoadingEnvioMagalu, setIsLoadingEnvioMagalu] = useState(false)
  const [selectedAnuncioForMagalu, setSelectedAnuncioForMagalu] = useState(null)
  const [accounts, setAccounts] = useState([])
  const [accountsOptions, setAccountsOptions] = useState([])

  // Estados de loading para integração em massa
  const [isIntegratingShopeeMass, setIsIntegratingShopeeMass] = useState(false)
  const [isIntegratingMagaluMass, setIsIntegratingMagaluMass] = useState(false)
  const [isMassIntegration, setIsMassIntegration] = useState(false)
  const [selectedMassAnuncios, setSelectedMassAnuncios] = useState([])
  const [integrationResult, setIntegrationResult] = useState({
    successCount: 0,
    failCount: 0,
    failedItems: [],
    platform: '',
  })
  const [showResultModal, setShowResultModal] = useState(false)
  const [sortBy, setSortBy] = useState('date_desc')
  const [statusFilter, setStatusFilter] = useState('all')
  const [healthFilter, setHealthFilter] = useState('all')
  const [ajustesMassa, setAjustesMassa] = useState({
    sku: '',
    quantidade: '',
  })
  const [isMassiveAdjustLoading, setIsMassiveAdjustLoading] = useState(false)
  const [resultadosAJusteEmMassa, setResultadosAJusteEmMassa] = useState({
    successCount: 0,
    failCount: 0,
    failedItems: [],
  })
  const [isModalResultadosMassaOpen, setIsModalResultadosMassaOpen] =
    useState(false)

  // Replicação Única e em lote
  const [isReplicarAnuncioLoading, setIsReplicarAnuncioLoading] =
    useState(false)
  const [isReplicarAnuncioBatchLoading, setIsReplicarAnuncioBatchLoading] =
    useState(false)
  const [isModalBatchReplicarOpen, setIsModalBatchReplicarOpen] =
    useState(false)
  const [isModalReplicarResultsOpen, setIsModalReplicarResultsOpen] =
    useState(false)
  const [isModalReplicarResultsBatchOpen, setIsModalReplicarResultsBatchOpen] =
    useState(false)
  const [replicarResults, setReplicarResults] = useState({
    success: {},
    error: {},
  })
  const [replicarResultsBatch, setReplicarResultsBatch] = useState({
    success: {},
    error: {},
  })

  const sortedConta = conta.sort((a, b) => a.APELIDO.localeCompare(b.APELIDO))

  const contasOptions = []

  for (const account of sortedConta) {
    const accountFind = contasOptions.find(
      (acc) => acc.value === account.ID_CONTA,
    )

    if (!accountFind?.value) {
      contasOptions.push({
        label: account.APELIDO,
        value: account.ID_CONTA,
      })
    }
  }

  const getFilteredAndSortedAnuncios = () => {
    let filtered = [...anunciosMl]

    // Aplicar filtro de status
    if (statusFilter !== 'all') {
      filtered = filtered.filter((anuncio) => anuncio.STATUS === statusFilter)
    }

    // Aplicar filtro de saúde
    if (healthFilter !== 'all') {
      filtered = filtered.filter((anuncio) => {
        const health = anuncio.HEALTH * 100
        switch (healthFilter) {
          case 'excellent':
            return health >= 80
          case 'good':
            return health >= 60 && health < 80
          case 'average':
            return health >= 40 && health < 60
          case 'poor':
            return health < 40
          default:
            return true
        }
      })
    }

    // Aplicar ordenação
    switch (sortBy) {
      case 'date_desc':
        return filtered.sort(
          (a, b) => new Date(b.DATE_CREATED) - new Date(a.DATE_CREATED),
        )
      case 'date_asc':
        return filtered.sort(
          (a, b) => new Date(a.DATE_CREATED) - new Date(b.DATE_CREATED),
        )
      case 'sales_desc':
        return filtered.sort(
          (a, b) => (b.SOLD_QUANTITY || 0) - (a.SOLD_QUANTITY || 0),
        )
      case 'sales_asc':
        return filtered.sort(
          (a, b) => (a.SOLD_QUANTITY || 0) - (b.SOLD_QUANTITY || 0),
        )
      case 'price_desc':
        return filtered.sort((a, b) => (b.PRICE || 0) - (a.PRICE || 0))
      case 'price_asc':
        return filtered.sort((a, b) => (a.PRICE || 0) - (b.PRICE || 0))
      case 'stock_desc':
        return filtered.sort(
          (a, b) => (b.AVAILABLE_QUANTITY || 0) - (a.AVAILABLE_QUANTITY || 0),
        )
      case 'stock_asc':
        return filtered.sort(
          (a, b) => (a.AVAILABLE_QUANTITY || 0) - (b.AVAILABLE_QUANTITY || 0),
        )
      case 'health_desc':
        return filtered.sort((a, b) => (b.HEALTH || 0) - (a.HEALTH || 0))
      case 'health_asc':
        return filtered.sort((a, b) => (a.HEALTH || 0) - (b.HEALTH || 0))
      default:
        return filtered
    }
  }

  function IntegrationResultModal({
    show,
    onClose,
    successCount,
    failCount,
    failedItems,
    platform = '',
  }) {
    const totalCount = successCount + failCount
    const successRate =
      totalCount > 0 ? ((successCount / totalCount) * 100).toFixed(1) : 0

    const getStatusConfig = () => {
      if (failCount === 0)
        return {
          variant: 'success',
          icon: '✓',
          color: '#10b981',
          bgColor: '#f0fdf4',
          title: 'Integração Concluída',
        }
      if (successCount === 0)
        return {
          variant: 'danger',
          icon: '✗',
          color: '#ef4444',
          bgColor: '#fef2f2',
          title: 'Falha na Integração',
        }
      return {
        variant: 'warning',
        icon: '⚠',
        color: '#f59e0b',
        bgColor: '#fffbeb',
        title: 'Integração Parcial',
      }
    }

    const status = getStatusConfig()

    return (
      <Modal
        show={show}
        onHide={onClose}
        centered
        size="lg"
      >
        <div
          style={{ border: 'none', borderRadius: '16px', overflow: 'hidden' }}
        >
          {/* Header moderno sem cores de fundo */}
          <Modal.Header
            closeButton
            style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
              border: 'none',
              padding: '24px 32px 20px',
              borderBottom: '1px solid #e2e8f0',
            }}
          >
            <div
              style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: status.bgColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '24px',
                  color: status.color,
                  fontWeight: 'bold',
                }}
              >
                {status.icon}
              </div>
              <div>
                <Modal.Title
                  style={{
                    margin: 0,
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#1e293b',
                    lineHeight: 1.2,
                  }}
                >
                  {status.title}
                </Modal.Title>
                {platform && (
                  <div
                    style={{
                      fontSize: '14px',
                      color: '#64748b',
                      marginTop: '4px',
                    }}
                  >
                    Plataforma: {platform}
                  </div>
                )}
              </div>
            </div>
          </Modal.Header>

          <Modal.Body style={{ padding: '32px' }}>
            {/* Cards de estatísticas modernos */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '16px',
                marginBottom: '24px',
              }}
            >
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                  border: '1px solid #bbf7d0',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: '28px',
                    fontWeight: '700',
                    color: '#059669',
                    marginBottom: '4px',
                  }}
                >
                  {successCount}
                </div>
                <div
                  style={{
                    fontSize: '13px',
                    color: '#047857',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Sucessos
                </div>
              </div>

              <div
                style={{
                  background:
                    'linear-gradient(135deg, #fef2f2 0%, #fef7f7 100%)',
                  border: '1px solid #fecaca',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: '28px',
                    fontWeight: '700',
                    color: '#dc2626',
                    marginBottom: '4px',
                  }}
                >
                  {failCount}
                </div>
                <div
                  style={{
                    fontSize: '13px',
                    color: '#b91c1c',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Falhas
                </div>
              </div>
            </div>

            {/* Barra de progresso moderna */}
            {totalCount > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#475569',
                      fontWeight: '500',
                    }}
                  >
                    Taxa de Sucesso
                  </span>
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '700',
                      color: status.color,
                    }}
                  >
                    {successRate}%
                  </span>
                </div>

                <div
                  style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      width: `${successRate}%`,
                      height: '100%',
                      background: `linear-gradient(90deg, ${status.color} 0%, ${status.color}dd 100%)`,
                      borderRadius: '8px',
                      transition: 'width 0.8s ease-in-out',
                    }}
                  />
                </div>
              </div>
            )}

            {/* Lista de erros moderna */}
            {failCount > 0 && (
              <div
                style={{
                  background: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '12px',
                  padding: '20px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '6px',
                      backgroundColor: '#fee2e2',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '8px',
                    }}
                  >
                    <span
                      style={{
                        color: '#dc2626',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      !
                    </span>
                  </div>
                  <h6
                    style={{
                      margin: 0,
                      fontSize: '16px',
                      color: '#991b1b',
                      fontWeight: '600',
                    }}
                  >
                    Anúncios com Erro ({failCount})
                  </h6>
                </div>

                <div
                  style={{
                    maxHeight: '180px',
                    overflowY: 'auto',
                    paddingRight: '8px',
                  }}
                >
                  {failedItems && failedItems.length > 0 ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                      }}
                    >
                      {failedItems.map((item, index) => (
                        <div
                          key={item.id || item || index}
                          style={{
                            background: '#ffffff',
                            border: '1px solid #f3f4f6',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            display: 'flex',
                            alignItems: 'flex-start',
                          }}
                        >
                          <div
                            style={{
                              width: '24px',
                              height: '24px',
                              borderRadius: '50%',
                              backgroundColor: '#fee2e2',
                              color: '#dc2626',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              fontWeight: '600',
                              marginRight: '12px',
                              flexShrink: 0,
                            }}
                          >
                            {index + 1}
                          </div>

                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: item.error ? '4px' : 0,
                              }}
                            >
                              {item.id || item}
                            </div>
                            {item.error && (
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6b7280',
                                  fontStyle: 'italic',
                                }}
                              >
                                {item.error}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        color: '#6b7280',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        padding: '20px',
                      }}
                    >
                      Nenhum detalhe disponível
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Mensagem de sucesso total */}
            {failCount === 0 && successCount > 0 && (
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                  border: '1px solid #bbf7d0',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div style={{ fontSize: '24px', marginBottom: '8px' }}>🎉</div>
                <div
                  style={{
                    fontWeight: '600',
                    color: '#047857',
                    fontSize: '16px',
                  }}
                >
                  Perfeito! Todos os {successCount} itens foram processados com
                  sucesso.
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer
            style={{
              background: '#f8fafc',
              border: 'none',
              padding: '20px 32px 24px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                color: '#64748b',
                fontWeight: '500',
              }}
            >
              Total processado: {totalCount} item{totalCount !== 1 ? 's' : ''}
            </div>

            <Button
              variant="outline-secondary"
              onClick={onClose}
              style={{
                borderRadius: '8px',
                padding: '8px 24px',
                fontWeight: '500',
                border: '1px solid #d1d5db',
                backgroundColor: '#ffffff',
                color: '#374151',
              }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  function ModalResultadosMassa({
    show,
    onClose,
    successCount,
    failCount,
    failedItems,
  }) {
    const totalCount = successCount + failCount
    const successRate =
      totalCount > 0 ? ((successCount / totalCount) * 100).toFixed(1) : 0

    const getStatusConfig = () => {
      if (failCount === 0)
        return {
          variant: 'success',
          icon: '✓',
          color: '#10b981',
          bgColor: '#f0fdf4',
          title: 'Alteração Concluída',
        }
      if (successCount === 0)
        return {
          variant: 'danger',
          icon: '✗',
          color: '#ef4444',
          bgColor: '#fef2f2',
          title: 'Falha na Alteração',
        }
      return {
        variant: 'warning',
        icon: '⚠',
        color: '#f59e0b',
        bgColor: '#fffbeb',
        title: 'Alteração Parcial',
      }
    }

    const status = getStatusConfig()

    console.log({
      successCount,
      failCount,
      failedItems,
      totalCount,
      successRate,
      status,
    })

    return (
      <Modal
        show={show}
        onHide={onClose}
        centered
        size="lg"
      >
        <div
          style={{ border: 'none', borderRadius: '16px', overflow: 'hidden' }}
        >
          {/* Header moderno sem cores de fundo */}
          <Modal.Header
            closeButton
            style={{
              background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
              border: 'none',
              padding: '24px 32px 20px',
              borderBottom: '1px solid #e2e8f0',
            }}
          >
            <div
              style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <div
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '12px',
                  background: status.bgColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: '16px',
                  fontSize: '24px',
                  color: status.color,
                  fontWeight: 'bold',
                }}
              >
                {status.icon}
              </div>
              <div>
                <Modal.Title
                  style={{
                    margin: 0,
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#1e293b',
                    lineHeight: 1.2,
                  }}
                >
                  {status.title}
                </Modal.Title>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body style={{ padding: '32px' }}>
            {/* Cards de estatísticas modernos */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '16px',
                marginBottom: '24px',
              }}
            >
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                  border: '1px solid #bbf7d0',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: '28px',
                    fontWeight: '700',
                    color: '#059669',
                    marginBottom: '4px',
                  }}
                >
                  {successCount}
                </div>
                <div
                  style={{
                    fontSize: '13px',
                    color: '#047857',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Sucessos
                </div>
              </div>

              <div
                style={{
                  background:
                    'linear-gradient(135deg, #fef2f2 0%, #fef7f7 100%)',
                  border: '1px solid #fecaca',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    fontSize: '28px',
                    fontWeight: '700',
                    color: '#dc2626',
                    marginBottom: '4px',
                  }}
                >
                  {failCount}
                </div>
                <div
                  style={{
                    fontSize: '13px',
                    color: '#b91c1c',
                    fontWeight: '500',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                  }}
                >
                  Falhas
                </div>
              </div>
            </div>

            {/* Barra de progresso moderna */}
            {totalCount > 0 && (
              <div style={{ marginBottom: '24px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '8px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '14px',
                      color: '#475569',
                      fontWeight: '500',
                    }}
                  >
                    Taxa de Sucesso
                  </span>
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: '700',
                      color: status.color,
                    }}
                  >
                    {successRate}%
                  </span>
                </div>

                <div
                  style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: '#f1f5f9',
                    borderRadius: '8px',
                    overflow: 'hidden',
                  }}
                >
                  <div
                    style={{
                      width: `${successRate}%`,
                      height: '100%',
                      background: `linear-gradient(90deg, ${status.color} 0%, ${status.color}dd 100%)`,
                      borderRadius: '8px',
                      transition: 'width 0.8s ease-in-out',
                    }}
                  />
                </div>
              </div>
            )}

            {/* Lista de erros moderna */}
            {failCount > 0 && (
              <div
                style={{
                  background: '#fef2f2',
                  border: '1px solid #fecaca',
                  borderRadius: '12px',
                  padding: '20px',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <div
                    style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '6px',
                      backgroundColor: '#fee2e2',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '8px',
                    }}
                  >
                    <span
                      style={{
                        color: '#dc2626',
                        fontSize: '14px',
                        fontWeight: 'bold',
                      }}
                    >
                      !
                    </span>
                  </div>
                  <h6
                    style={{
                      margin: 0,
                      fontSize: '16px',
                      color: '#991b1b',
                      fontWeight: '600',
                    }}
                  >
                    Anúncios com Erro ({failCount})
                  </h6>
                </div>

                <div
                  style={{
                    maxHeight: '180px',
                    overflowY: 'auto',
                    paddingRight: '8px',
                  }}
                >
                  {failedItems && failedItems.length > 0 ? (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                      }}
                    >
                      {failedItems.map((item, index) => (
                        <div
                          key={item.id || item || index}
                          style={{
                            background: '#ffffff',
                            border: '1px solid #f3f4f6',
                            borderRadius: '8px',
                            padding: '12px 16px',
                            display: 'flex',
                            alignItems: 'flex-start',
                          }}
                        >
                          <div
                            style={{
                              width: '24px',
                              height: '24px',
                              borderRadius: '50%',
                              backgroundColor: '#fee2e2',
                              color: '#dc2626',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              fontWeight: '600',
                              marginRight: '12px',
                              flexShrink: 0,
                            }}
                          >
                            {index + 1}
                          </div>

                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontWeight: '600',
                                color: '#374151',
                                marginBottom: item.error ? '4px' : 0,
                              }}
                            >
                              {item.id || item}
                            </div>
                            {item.error && (
                              <div
                                style={{
                                  fontSize: '13px',
                                  color: '#6b7280',
                                  fontStyle: 'italic',
                                }}
                              >
                                {item.error}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p
                      style={{
                        margin: 0,
                        color: '#6b7280',
                        fontStyle: 'italic',
                        textAlign: 'center',
                        padding: '20px',
                      }}
                    >
                      Nenhum detalhe disponível
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Mensagem de sucesso total */}
            {failCount === 0 && successCount > 0 && (
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #ecfdf5 0%, #f0fdf4 100%)',
                  border: '1px solid #bbf7d0',
                  borderRadius: '12px',
                  padding: '20px',
                  textAlign: 'center',
                }}
              >
                <div style={{ fontSize: '24px', marginBottom: '8px' }}>🎉</div>
                <div
                  style={{
                    fontWeight: '600',
                    color: '#047857',
                    fontSize: '16px',
                  }}
                >
                  Perfeito! Todos os {successCount} anúncios e suas variantes
                  foram alterados com sucesso.
                </div>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer
            style={{
              background: '#f8fafc',
              border: 'none',
              padding: '20px 32px 24px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: '14px',
                color: '#64748b',
                fontWeight: '500',
              }}
            >
              Total processado: {totalCount} item{totalCount !== 1 ? 's' : ''}
            </div>

            <Button
              variant="outline-secondary"
              onClick={onClose}
              style={{
                borderRadius: '8px',
                padding: '8px 24px',
                fontWeight: '500',
                border: '1px solid #d1d5db',
                backgroundColor: '#ffffff',
                color: '#374151',
              }}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }

  // Shopee
  const handleOpenShopeeMassModal = () => {
    if (selectedRows.length === 0) {
      toast.warning('Selecione ao menos 1 anúncio')
      return
    }
    setIsMassIntegration(true)
    setSelectedMassAnuncios(
      anunciosMl.filter((a) => selectedRows.includes(a.CODIGOMK)),
    )
    setShowModalShopee(true)
    buscarContasShopee()
  }

  // Magalu
  const handleOpenMagaluMassModal = () => {
    if (selectedRows.length === 0) {
      toast.warning('Selecione ao menos 1 anúncio')
      return
    }
    setIsMassIntegration(true)
    setSelectedMassAnuncios(
      anunciosMl.filter((a) => selectedRows.includes(a.CODIGOMK)),
    )
    setShowModalMagalu(true)
    buscarContasMagalu()
  }

  {
    isMassIntegration ? (
      <Alert variant="info">
        Você está integrando <strong>{selectedMassAnuncios.length}</strong>{' '}
        anúncios em massa.
      </Alert>
    ) : (
      selectedAnuncioForShopee && (
        <div className="mb-4">
          <div
            style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}
          >
            <img
              src={selectedAnuncioForShopee.THUMBNAIL}
              alt="Produto"
              style={{
                width: 80,
                height: 80,
                objectFit: 'cover',
                borderRadius: 8,
                marginRight: 16,
              }}
            />
            <div>
              <h6 style={{ margin: 0, marginBottom: 4 }}>
                {selectedAnuncioForShopee.TITLE}
              </h6>
              <small style={{ color: '#6c757d' }}>
                MLB: {selectedAnuncioForShopee.CODIGOMK}
              </small>
            </div>
          </div>
          <hr />
        </div>
      )
    )
  }

  const handleIntegrateWithShopeeMass = async () => {
    if (!contaShopeeSelected || selectedRows.length === 0) {
      toast.warning('Selecione ao menos 1 anúncio e a conta Shopee')
      return
    }

    try {
      setIsIntegratingShopeeMass(true)

      for (const codMk of selectedRows) {
        await apinode.get(`/mltoshopee/${localStorage.idconta}`, {
          params: {
            mlb: codMk,
            idshopee: contaShopeeSelected,
            id_conta: contaSelecionada,
          },
        })
      }

      toast.success('Todos os anúncios foram integrados com a Shopee!')
      setSelectedRows([])
    } catch (err) {
      console.error('Erro na integração em massa com Shopee:', err)
      toast.error('Falha ao integrar alguns anúncios com a Shopee')
    } finally {
      setIsIntegratingShopeeMass(false)
    }
  }

  const handleIntegrateWithMagaluMass = async () => {
    if (!contaMagaluSelected || selectedRows.length === 0) {
      toast.warning('Selecione ao menos 1 anúncio e a conta Magalu')
      return
    }

    try {
      setIsIntegratingMagaluMass(true)

      for (const codMk of selectedRows) {
        await apinode.get(`/mltomagalu/${localStorage.idconta}`, {
          params: {
            mlb: codMk,
            idmagalu: contaMagaluSelected,
            id_conta: contaSelecionada,
          },
        })
      }

      toast.success('Todos os anúncios foram integrados com o Magalu!')
      setSelectedRows([])
    } catch (err) {
      console.error('Erro na integração em massa com Magalu:', err)
      toast.error('Falha ao integrar alguns anúncios com o Magalu')
    } finally {
      setIsIntegratingMagaluMass(false)
    }
  }

  // Add this function to fetch Magalu accounts
  const buscarContasMagalu = async () => {
    try {
      setIsLoadingMagaluContas(true)
      const response = await apinode.get(`/listmagalu/${localStorage.idconta}`)

      if (response.status === 200) {
        setContasMagalu(response.data.data)
        if (response.data.data.length > 0) {
          setContaMagaluSelected(
            response.data.data[0].ID_CONTA || response.data[0].id,
          )
        }
      }
    } catch (error) {
      console.error('Erro ao buscar contas do Magalu:', error)
      toast.error('Erro ao carregar contas do Magalu')
    } finally {
      setIsLoadingMagaluContas(false)
    }
  }

  // Add this function to handle opening the Magalu modal
  const handleOpenMagaluModal = (anuncio) => {
    setSelectedAnuncioForMagalu(anuncio)
    setShowModalMagalu(true)
    buscarContasMagalu()
  }

  // Função auxiliar para tratar retorno Shopee/Magalu
  const validateResponse = (platform, data) => {
    if (!data) return { success: false, error: 'Resposta vazia' }

    if (platform === 'Shopee') {
      const hasError = data.result?.error || data.result?.debug_message
      if (hasError) {
        return {
          success: false,
          error: data.result?.message || 'Erro desconhecido (Shopee)',
        }
      }
      return { success: true }
    }

    if (platform === 'Magalu') {
      if (data.success && data.productExists) {
        return { success: false, error: 'Produto já existe no Magalu' }
      }
      if (data.success === false) {
        return {
          success: false,
          error: data.message || 'Erro desconhecido (Magalu)',
        }
      }
      return { success: true }
    }

    return { success: false, error: 'Plataforma não mapeada' }
  }

  const handleIntegrateWithShopee = async () => {
    try {
      setIsloadingEnvio(true)

      let successCount = 0
      let failCount = 0
      let failedItems = []

      if (isMassIntegration) {
        // Integração em massa
        for (const anuncio of selectedMassAnuncios) {
          try {
            const { data } = await apinode.get(
              `/mltoshopee/${localStorage.idconta}`,
              {
                params: {
                  mlb: anuncio.CODIGOMK,
                  idshopee: contaShopeeSelected,
                  id_conta: contaSelecionada,
                },
              },
            )

            const result = validateResponse('Shopee', data)

            if (result.success) {
              successCount++
            } else {
              failCount++
              failedItems.push({ id: anuncio.CODIGOMK, error: result.error })
            }
          } catch (err) {
            failCount++
            failedItems.push({
              id: anuncio.CODIGOMK,
              error: err.response?.data?.message || 'Erro inesperado de rede',
            })
          }
        }
      } else {
        // Integração unitária
        try {
          const { data } = await apinode.get(
            `/mltoshopee/${localStorage.idconta}`,
            {
              params: {
                mlb: selectedAnuncioForShopee.CODIGOMK,
                idshopee: contaShopeeSelected,
                id_conta: contaSelecionada,
              },
            },
          )

          const result = validateResponse('Shopee', data)

          if (result.success) {
            successCount = 1
          } else {
            failCount = 1
            failedItems.push({
              id: selectedAnuncioForShopee.CODIGOMK,
              error: result.error,
            })
          }
        } catch (err) {
          failCount = 1
          failedItems.push({
            id: selectedAnuncioForShopee.CODIGOMK,
            error: err.response?.data?.message || 'Erro inesperado de rede',
          })
        }
      }

      // Definir resultado e mostrar modal
      setIntegrationResult({
        successCount,
        failCount,
        failedItems,
        platform: 'Shopee',
      })
      setShowResultModal(true)

      // Limpar estados
      setShowModalShopee(false)
      setSelectedRows([])
      setIsMassIntegration(false)
    } catch (error) {
      console.error('Erro inesperado ao integrar com Shopee:', error)
      setIntegrationResult({
        successCount: 0,
        failCount: 1,
        failedItems: [{ id: 'Erro geral', error: 'Erro inesperado' }],
        platform: 'Shopee',
      })
      setShowResultModal(true)
    } finally {
      setIsloadingEnvio(false)
    }
  }

  const handleIntegrateWithMagalu = async () => {
    try {
      setIsLoadingEnvioMagalu(true)

      let successCount = 0
      let failCount = 0
      let failedItems = []

      if (isMassIntegration) {
        // Integração em massa
        for (const anuncio of selectedMassAnuncios) {
          try {
            const { data } = await apinode.get(
              `/mltomagalu/${localStorage.idconta}`,
              {
                params: {
                  mlb: anuncio.CODIGOMK,
                  idmagalu: contaMagaluSelected,
                  id_conta: contaSelecionada,
                },
              },
            )

            const result = validateResponse('Magalu', data)

            if (result.success) {
              successCount++
            } else {
              failCount++
              failedItems.push({ id: anuncio.CODIGOMK, error: result.error })
            }
          } catch (err) {
            failCount++
            failedItems.push({
              id: anuncio.CODIGOMK,
              error: err.response?.data?.message || 'Erro inesperado de rede',
            })
          }
        }
      } else {
        // Integração unitária
        try {
          const { data } = await apinode.get(
            `/mltomagalu/${localStorage.idconta}`,
            {
              params: {
                mlb: selectedAnuncioForMagalu.CODIGOMK,
                idmagalu: contaMagaluSelected,
                id_conta: contaSelecionada,
              },
            },
          )

          const result = validateResponse('Magalu', data)

          if (result.success) {
            successCount = 1
          } else {
            failCount = 1
            failedItems.push({
              id: selectedAnuncioForMagalu.CODIGOMK,
              error: result.error,
            })
          }
        } catch (err) {
          failCount = 1
          failedItems.push({
            id: selectedAnuncioForMagalu.CODIGOMK,
            error: err.response?.data?.message || 'Erro inesperado de rede',
          })
        }
      }

      // Definir resultado e mostrar modal
      setIntegrationResult({
        successCount,
        failCount,
        failedItems,
        platform: 'Magalu',
      })
      setShowResultModal(true)

      // Limpar estados
      setShowModalMagalu(false)
      setSelectedRows([])
      setIsMassIntegration(false)
    } catch (error) {
      console.error('Erro inesperado ao integrar com Magalu:', error)
      setIntegrationResult({
        successCount: 0,
        failCount: 1,
        failedItems: [{ id: 'Erro geral', error: 'Erro inesperado' }],
        platform: 'Magalu',
      })
      setShowResultModal(true)
    } finally {
      setIsLoadingEnvioMagalu(false)
    }
  }

  // 5. Renderização do modal corrigida (substituir as duas chamadas existentes)
  ;<IntegrationResultModal
    show={showResultModal}
    onClose={() => setShowResultModal(false)}
    successCount={integrationResult.successCount}
    failCount={integrationResult.failCount}
    failedItems={integrationResult.failedItems}
    platform={integrationResult.platform}
  />

  const buscarContasShopee = async () => {
    try {
      setIsLoadingShopeeContas(true)
      const response = await apinode.get(`/listshopee/${localStorage.idconta}`)

      if (response.status === 200) {
        setContasShopee(response.data.data)
        if (response.data.data.length > 0) {
          setContaShopeeSelected(
            response.data.data[0].ID_CONTA || response.data[0].id,
          )
        }
      }
    } catch (error) {
      console.error('Erro ao buscar contas da Shopee:', error)
      toast.error('Erro ao carregar contas da Shopee')
    } finally {
      setIsLoadingShopeeContas(false)
    }
  }

  // Add this function to handle opening the Shopee modal
  const handleOpenShopeeModal = (anuncio) => {
    setSelectedAnuncioForShopee(anuncio)
    setShowModalShopee(true)
    buscarContasShopee()
  }

  const handleSearchChangeVariant = async () => {
    if (anuncioSkuVariant) {
      setIsSkuVarianteLoading(true)
      try {
        const response = await apinode.get(`/estoque/listaproduto`, {
          params: { sku: anuncioSkuVariant, conta: localStorage.idconta },
        })
        setFilteredVariantes(response.data)
      } catch (error) {
        console.error('Erro ao buscar variantes:', error)
      } finally {
        setIsSkuVarianteLoading(false)
      }
    } else {
      setFilteredVariantes([])
    }
  }
  const handleSelectVariant = (sku) => {
    setAnuncioSkuVariant(sku) // Define o SKU selecionado no campo de input
    setFilteredVariantes([]) // Limpa a lista de variantes
  }

  // Função para manipular o evento de seleção/deseleção da caixa de seleção
  const handleCheckboxChange = (anuncioId) => {
    setSelectedRows((prevSelectedRows) => {
      // Se o anuncioId já estiver no array, remove; se não, adiciona
      const isSelected = prevSelectedRows.includes(anuncioId)
      const updatedRows = isSelected
        ? prevSelectedRows.filter((id) => id !== anuncioId)
        : [...prevSelectedRows, anuncioId]

      return updatedRows
    })
  }

  async function handleConfirmGenerateEAN(codigoMk, idvariacao, index) {
    Swal.fire({
      title: 'Você deseja gerar um EAN novo?',
      showDenyButton: true,
      confirmButtonText: 'Sim',
      denyButtonText: `Não`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await generateEAN(codigoMk, idvariacao, index)
      }
    })
  }

  async function handlePauseSelectedVariants() {
    try {
      setIsSelectedVariantsLoading(true)

      for (const variantId of selectedVariantsIds) {
        await apinode.put(
          `/anuncios/variacoes/${selectedCodigoMk}/${variantId}/${contaSelecionada}`,
          {
            quantity: 0,
          },
        )

        setTimeout(() => {
          console.log('bora', variantId)
        }, 1000)
      }

      toast.success('Variantes pausadas com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível pausar o anúncio!')
    } finally {
      setIsSelectedVariantsLoading(false)
    }
  }

  async function getVariants(codigoMk, index) {
    if (!selectedAnuncio[index]) {
      try {
        setIsVariantsLoading((prevState) => ({
          ...prevState,
          [index]: true,
        }))

        const response = await apinode.get(
          `/anuncios/variants/${codigoMk}/${localStorage.idconta}`,
          {
            params: {
              id_conta: contaSelecionada,
              skuComposicao: searchComposicao,
            },
          },
        )

        setSelectedAnuncio({
          [index]: response.data,
        })
      } catch (err) {
        sendErrorApiMessage(err, 'Não foi possível buscar as variações!')
      } finally {
        setIsVariantsLoading((prevState) => ({
          ...prevState,
          [index]: false,
        }))
      }
    } else {
      setSelectedAnuncio({})
    }
  }

  const handleClearSelection = async () => {
    setSelectedRows([]) // Define o array de seleção como vazio para desmarcar todos os itens
  }

  const handleConfirm = () => {
    // Perform any validation if needed before updating stock
    handleUpdateStock(newStock)
    handleClose()
  }

  function handleSetStateReplicar(status, conta, value) {
    setReplicarResults((prevState) => {
      if (prevState?.[status]?.[conta]) {
        return {
          ...prevState,
          [status]: {
            ...prevState[status],
            [conta]: [...prevState[status][conta], value],
          },
        }
      } else {
        return {
          ...prevState,
          [status]: {
            ...prevState[status],
            [conta]: [value],
          },
        }
      }
    })
  }

  function handleSetStateReplicarBatch(status, mlb, conta, value) {
    console.log(status, mlb, conta, value)

    setReplicarResultsBatch((prevState) => {
      if (prevState?.[status]?.[mlb]?.[conta]) {
        return {
          ...prevState,
          [status]: {
            ...prevState[status],
            [mlb]: {
              ...prevState[status][mlb],
              [conta]: [...prevState[status][mlb][conta], value],
            },
          },
        }
      } else {
        return {
          ...prevState,
          [status]: {
            ...prevState[status],
            [mlb]: {
              ...prevState[status][mlb],
              [conta]: [value],
            },
          },
        }
      }
    })
  }

  async function handleConfirmVariant() {
    try {
      setIsQuantityVariantLoading(true)

      await apinode.put(
        `/anuncios/variacoes/${mlb}/${selectedIdVariacao}/${contaSelecionada}`,
        {
          quantity: Number(newStockVariante),
        },
      )

      toast.success('Estoque da variante alterado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar a quantidade!')
    } finally {
      setIsQuantityVariantLoading(false)
      setShowModalVariante(false)
    }
  }

  async function handleReplicarAnuncio() {
    setReplicarResults({ success: {}, error: {} })
    setIsReplicarAnuncioLoading(true)

    const promises = []

    for (const account of accounts) {
      promises.push(
        apinode.post(`/anuncios/replicar/${contaSelecionada}?batchMode=true`, {
          codigoMk: selectedCodigoMk,
          contaDestino: account.value,
        }),
      )
    }

    const results = await Promise.allSettled(promises)

    for (const [index, result] of results.entries()) {
      console.log(result)

      if (result.status === 'rejected') {
        const contaDestino = JSON.parse(
          result?.reason?.config?.data,
        )?.contaDestino
        const contaLabel = accountsOptions.find(
          (accountOption) => accountOption.value == contaDestino,
        )?.label

        let mensagemErro = 'Não foi possível replicar o anúncio!'

        const data = result.reason?.response?.data

        if (Array.isArray(data?.data?.cause)) {
          console.log('caiu no cause')

          if (data?.data?.cause.length > 0) {
            data.data.cause
              .filter((c) => c.type === 'error')
              .map((c) => `${c.message}`)
              .forEach((message) => {
                handleSetStateReplicar('error', contaLabel, message)
              })
          } else {
            handleSetStateReplicar('error', contaLabel, data?.data?.message)
          }
        } else if (data?.error) {
          console.log('caiu no error')

          handleSetStateReplicar('error', contaLabel, data.error)
        } else if (data?.message) {
          console.log('caiu no message')

          handleSetStateReplicar('error', contaLabel, data.message)
        } else {
          console.log('caiu no mensagem default')

          handleSetStateReplicar('error', contaLabel, mensagemErro)
        }
      } else {
        const contaDestino = JSON.parse(
          result?.value?.config?.data,
        )?.contaDestino
        const contaLabel = accountsOptions.find(
          (accountOption) => accountOption.value == contaDestino,
        )?.label

        handleSetStateReplicar('success', contaLabel, 'Replicado com sucesso')
      }

      if (index === results.length - 1) {
        setIsModalReplicarResultsOpen(true)
      }
    }

    setAccounts([])
    setIsReplicarAnuncioLoading(false)
    setShowModalReplicar(false)
  }

  async function handleReplicarAnuncioBatch() {
    setReplicarResultsBatch({ success: {}, error: {} })
    setIsReplicarAnuncioBatchLoading(true)

    const promises = []

    for (const codigoMk of selectedRows) {
      for (const account of accounts) {
        promises.push(
          apinode.post(
            `/anuncios/replicar/${contaSelecionada}?batchMode=true`,
            {
              codigoMk,
              contaDestino: account.value,
            },
          ),
        )
      }
    }

    const results = await Promise.allSettled(promises)

    for (const [index, result] of results.entries()) {
      console.log(result)

      if (result.status === 'rejected') {
        const codigoMk = JSON.parse(result.reason?.config?.data)?.codigoMk
        const contaDestino = JSON.parse(
          result.reason?.config?.data,
        )?.contaDestino
        const contaLabel = accountsOptions.find(
          (accountOption) => accountOption.value == contaDestino,
        )?.label

        let mensagemErro = 'Não foi possível replicar o anúncio!'

        const data = result.reason?.response?.data

        if (Array.isArray(data?.data?.cause)) {
          data.data.cause
            .filter((c) => c.type === 'error')
            .map((c) => `${c.message}`)
            .forEach((message) => {
              handleSetStateReplicarBatch(
                'error',
                codigoMk,
                contaLabel,
                message,
              )
            })
        } else if (data?.error) {
          handleSetStateReplicarBatch('error', codigoMk, contaLabel, data.error)
        } else if (data?.message) {
          handleSetStateReplicarBatch(
            'error',
            codigoMk,
            contaLabel,
            data.message,
          )
        } else {
          handleSetStateReplicarBatch(
            'error',
            codigoMk,
            contaLabel,
            mensagemErro,
          )
        }
      } else {
        const codigoMk = JSON.parse(result.value?.config?.data)?.codigoMk
        const contaDestino = JSON.parse(
          result.value?.config?.data,
        )?.contaDestino
        const contaLabel = accountsOptions.find(
          (accountOption) => accountOption.value == contaDestino,
        )?.label

        handleSetStateReplicarBatch(
          'success',
          codigoMk,
          contaLabel,
          'Replicado com sucesso',
        )
      }

      if (index === results.length - 1) {
        setIsModalReplicarResultsBatchOpen(true)
      }
    }

    setIsReplicarAnuncioBatchLoading(false)
    setAccounts([])
    setIsModalBatchReplicarOpen(false)
    setSelectedRows([])
  }

  async function handleConfirmSKUAnuncio() {
    try {
      setIsSkuAnuncioLoading(true)

      await apinode.put(
        `/anuncios/sku/${selectedCodigoMk}/${contaSelecionada}`,
        {
          sku: anuncioSku,
        },
      )

      toast.success('SKU do anúncio atualizado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o SKU!')
    } finally {
      setIsSkuAnuncioLoading(false)
      setShowModalSku(false)
    }
  }

  async function handleConfirmVariantPrice() {
    try {
      setIsVariantPriceLoading(true)

      await apinode.put(
        `/anuncios/variants/price/${selectedCodigoMk}/${selectedIdVariacao}/${contaSelecionada}`,
        {
          price: adaptValue(variantPrice),
        },
      )

      toast.success('Preço da variante alterada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o preço!')
    } finally {
      setIsVariantPriceLoading(false)
      setShowModalPrice(false)
    }
  }

  async function generateEAN(codigoMk, idvariacao, index) {
    try {
      setIsGenerateEANLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await apinode.put(
        `/anuncios/variants/ean/${codigoMk}/${idvariacao}/${contaSelecionada}`,
      )

      toast.success('EAN gerado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível gerar o EAN!')
    } finally {
      setIsGenerateEANLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function handleConfirmSKUVariante() {
    try {
      setIsSkuVarianteLoading(true)

      await apinode.put(
        `/anuncios/variants/sku/${selectedCodigoMk}/${selectedIdVariacao}/${contaSelecionada}`,
        {
          sku: anuncioSkuVariant,
        },
      )

      toast.success('SKU da variante atualizado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o SKU!')
    } finally {
      setIsSkuVarianteLoading(false)
      setShowModalSkuVariant(false)
    }
  }

  async function handleConfirmVariant() {
    try {
      setIsSkuAnuncioLoading(true)

      await apinode.put(
        `/anuncios/variacoes/${mlb}/${selectedIdVariacao}/${contaSelecionada}`,
        {
          quantity: Number(newStockVariante),
        },
      )

      toast.success('Estoque da variante alterado com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar a quantidade!')
    } finally {
      setIsSkuAnuncioLoading(false)
      setShowModalVariante(false)
    }
  }

  const handleClose = () => {
    // Perform any validation if needed before updating stock
    // handleUpdateStock(newStock);
    setShowModal(false)
  }

  const ActiveAll = async () => {
    try {
      const requestData = {
        seller: contaSelecionada,
        items: selectedRows,
      }

      const response = await apinode.put(
        `anuncios/sincronizar/anuncios/activeall/${localStorage.idconta}`,
        requestData,
      )

      if (response.status === 200) {
        swal('Sucesso!', 'Sucesso ao ativar anúncios', 'success')
      } else {
        console.log(
          'Erro ao ativar anúncios. Código de status:',
          response.status,
        )
        swal('Erro!', 'Erro ao ativar anúncios', 'error')
      }
    } catch (error) {
      console.error('Erro ao ativar anúncios:', error)
      swal('Erro!', 'Erro ao ativar anúncios', 'error')
    }
  }
  const PausedAll = async () => {
    try {
      const requestData = {
        seller: contaSelecionada,
        items: selectedRows,
      }

      const response = await apinode.put(
        `anuncios/sincronizar/anuncios/pausedall/${localStorage.idconta}`,
        requestData,
      )

      if (response.status === 200) {
        swal('Sucesso!', 'Sucesso ao pausar anúncios', 'success')
        await handleClearSelection()
      } else {
        console.log(
          'Erro ao pausar anúncios. Código de status:',
          response.status,
        )
        swal('Erro!', 'Erro ao pausar anúncios', 'error')
      }
    } catch (error) {
      console.error('Erro ao pausar anúncios:', error)
      swal('Erro!', 'Erro ao pausar anúncios', 'error')
    }
  }

  const buscarContasMercadoLibre = useCallback(async () => {
    setAccountsOptions([])

    try {
      const response = await apinode.get(
        `anuncios/contas/${localStorage.idconta}`,
      )

      const accountsFormatted = response.data
        .sort((a, b) => a.APELIDO.localeCompare(b.APELIDO))
        .map((account) => ({
          label: account.APELIDO,
          value: account.ID_CONTA,
        }))

      setAccountsOptions(accountsFormatted)

      setContas(response.data)
      setContaSelecionada(response.data[0].ID_CONTA)
      setContaReplicar(response.data[0].ID_CONTA)
      await buscarDados(response.data[0].ID_CONTA)
    } catch (error) {
      console.error('Erro ao buscar contas do Mercado Livre:', error)
    }
  }, [])

  const outrasContas = useMemo(() => {
    return conta.filter((option) => option.ID_CONTA !== contaSelecionada)
  }, [conta, contaSelecionada])

  const statusMapping = {
    active: 'Ativo',
    inactive: 'Inativo',
    paused: 'Pausado',
    under_review: 'Em revisão',
    // Adicione mais estados conforme necessário
  }
  const CircularProgressBar = ({ percentage }) => {
    const data = {
      datasets: [
        {
          data: [percentage, 100 - percentage],
          backgroundColor: [
            'rgba(40, 167, 69, 0.8)',
            'rgba(214, 214, 214, 0.2)',
          ],
          borderWidth: -5, // Ajuste o valor conforme necessário
        },
      ],
    }

    const options = {
      cutoutPercentage: 50,
      plugins: {
        legend: false,
        tooltip: false,
      },
    }

    return (
      <div style={{ position: 'relative' }}>
        <Doughnut
          data={data}
          options={options}
        />

        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            width: '100%',
          }}
        >
          <span style={{ color: 'green', fontSize: '12px' }}>
            {percentage}%
          </span>
        </div>
      </div>
    )
  }

  const anunciosPerPage = 20 // Número de anúncios por página

  const pagesVisited = pageNumber * anunciosPerPage

  const pageCount = Math.ceil(anunciosMl.length / anunciosPerPage)

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption)
  }

  const buscarDadosPesquisa = async () => {
    // Clear previously selected ad data
    setSelectedAnuncio({})

    try {
      // Set loading state to true before fetching data
      setLoading(true)

      // Create params object with required seller and status fields
      const params = {
        seller: contaSelecionada,
        status: selectedStatus?.value, // Use optional chaining in case selectedStatus is undefined
      }

      // Add additional search criteria based on the 'tipo' value
      if (tipo === 'mlb') params.mlb = pesquisa
      if (tipo === 'sku') params.sku = pesquisa
      if (tipo === 'title') params.title = pesquisa

      // Make API request with constructed parameters
      const response = await apinode.get(
        `/anuncios/search/${localStorage.idconta}`,
        { params },
      )

      // Update state with the fetched data
      setAnunciosMl(response.data)
    } catch (error) {
      // Handle and log any errors during data fetching
      swal('Ops!', 'Erro ao buscar anúncios', 'warning')
      console.error('Ops! Ocorreu um erro:', error)
    } finally {
      // Always set loading to false after data fetching or error
      setLoading(false)
    }
  }

  async function handleMassiveAdjust() {
    try {
      setIsMassiveAdjustLoading(true)

      const response = await apinode.post(
        `/anuncios/ajustes-em-massa/${ajustesMassa.sku}/${localStorage.idconta}?seller=${contaSelecionada}`,
        {
          quantidade: ajustesMassa.quantidade,
        },
      )

      let successCount = 0
      let failCount = 0
      let failedItems = []

      for (const anuncio of response.data.resultadoAnuncios) {
        if (anuncio.status === 'success') {
          successCount += 1
        } else {
          failCount += 1

          failedItems.push({
            id: anuncio.mlb,
            error: String(variante),
          })
        }
      }

      for (const variante of response.data.resultadoVariantes) {
        if (variante.status === 'success') {
          successCount += 1
        } else {
          failCount += 1

          failedItems.push({
            id: variante.mlb,
            error: String(variante.err),
          })
        }
      }

      setResultadosAJusteEmMassa({ successCount, failCount, failedItems })
      setIsModalAjustesMassaOpen(false)
      setIsModalResultadosMassaOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível fazer os ajustes')
    } finally {
      setIsMassiveAdjustLoading(false)
    }
  }

  const handlePausedAnuncio = async (mlb, seller_id) => {
    try {
      const response = await apinode.get(
        `/anuncios/sincronizar/anuncios/paused/${localStorage.idconta}`,
        {
          params: {
            seller: seller_id,
            item_id: mlb,
          },
        },
      )

      if (response.data.success === true) {
        swal('Anúncio pausado com sucesso!', '', 'success')
      }
    } catch (error) {
      swal('Ops!', 'Erro ao buscar anúncios', 'warning')
      console.error('Ops! Ocorreu um erro:', error)
    }
  }

  async function excluirAnuncio(anuncio, index) {
    try {
      setIsDeleteAnuncioLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await apinode.delete(
        `/anuncios/${anuncio.CODIGOMK}/${localStorage.idconta}`,
      )

      toast.success('Anúncio deletado com sucesso!')
      buscarContasMercadoLibre()
    } catch (err) {
      sendErrorApiMessage(err)
    } finally {
      setIsDeleteAnuncioLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  const handleActivedAnuncio = async (mlb, seller_id) => {
    try {
      const response = await apinode.get(
        `/anuncios/sincronizar/anuncios/actived/${localStorage.idconta}`,
        {
          params: {
            seller: seller_id,
            item_id: mlb,
          },
        },
      )

      if (response.data.success === true) {
        swal('Anúncio ativo com sucesso!', '', 'success')
      }
    } catch (error) {
      swal('Ops!', 'Erro ao buscar anúncios', 'warning')
      console.error('Ops! Ocorreu um erro:', error)
    }
  }

  const confirmActionAndHandleAnuncio = (
    actionName,
    confirmationMessage,
    actionCallback,
  ) => {
    const isConfirmed = window.confirm(confirmationMessage)

    if (isConfirmed) {
      actionCallback()
    } else {
      // Handle cancellation or do nothing
    }
  }

  const handleUpdateStock = async (newStock) => {
    try {
      const response = await apinode.put(
        `/anuncios/sincronizar/anuncios/available_quantity/${localStorage.idconta}`,
        {
          seller: seller,
          item_id: mlb,
          quantity: newStock,
        },
        // Configuração para indicar que os dados são do tipo JSON
        { headers: { 'Content-Type': 'application/json' } },
      )

      if (response.status === 200) {
        swal('Alteração de estoque realizada com sucesso!', '', 'success')
      } else {
        // Exibe a mensagem de erro vinda da resposta
        swal('Ops!', response.data.error || 'Erro desconhecido', 'warning')
      }
    } catch (error) {
      // Trata o erro geral e exibe a mensagem associada (se houver)
      if (error.response) {
        swal(
          'Ops!',
          error.response.data.error || 'Erro desconhecido',
          'warning',
        )
      } else {
        swal('Ops!', 'Ocorreu um erro desconhecido', 'warning')
      }
      console.error('Ops! Ocorreu um erro:', error)
    }
  }

  function openModalVariant(mlb, seller_id, title, id_variacao) {
    setMlb(mlb)
    setSeller(seller_id)
    setProdutonome(title)
    setSelectedIdVariacao(id_variacao)

    setShowModalVariante(true)
  }

  const confirmActionAndOpenModal = (mlb, seller_id, title) => {
    ;(setMlb(mlb), setSeller(seller_id), setProdutonome(title))
    setShowModal(true)
  }

  const handlePausarAnunciosSelecionados = async () => {
    // Exibir uma caixa de diálogo de confirmação
    const confirmacao = window.confirm(
      'Tem certeza de que deseja pausar todos os anúncios selecionados?',
    )

    // Se o usuário confirmar, execute a lógica para pausar anúncios
    if (confirmacao) {
      await PausedAll()
    }
  }

  const handleAtivarAnunciosSelecionados = async () => {
    // Exibir uma caixa de diálogo de confirmação
    const confirmacao = window.confirm(
      'Tem certeza de que deseja ativar todos os anúncios selecionados?',
    )

    // Se o usuário confirmar, execute a lógica para ativar anúncios
    if (confirmacao) {
      await ActiveAll()
    }
  }

  const handleTipoChange = (newTipo) => {
    setTipo(newTipo)
  }

  async function handlePauseVariantQuantity(
    codigoMk,
    idVariacao,
    variantIndex,
  ) {
    try {
      setIsPausedLoading((prevState) => ({
        ...prevState,
        [variantIndex]: true,
      }))

      await apinode.put(
        `/anuncios/variacoes/${codigoMk}/${idVariacao}/${contaSelecionada}`,
        {
          quantity: 0,
        },
      )

      toast.success('Variante pausada com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível pausar a variante!')
    } finally {
      setIsPausedLoading((prevState) => ({
        ...prevState,
        [variantIndex]: false,
      }))
    }
  }

  async function handleSearchVariacao() {
    setSelectedAnuncio({})

    try {
      setIsLoadingSearch(true)

      const response = await apinode.get(
        `/anuncios/variacoes/${contaSelecionada}?search=${searchVariacao}`,
      )

      setAnunciosMl(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as variações!')
    } finally {
      setIsLoadingSearch(false)
    }
  }

  async function buscarAnunciosSemSku() {
    setSelectedAnuncio({})

    try {
      setIsNoSkuAnunciosLoading(true)
      const response = await apinode.get(`/anuncios/no-sku/${contaSelecionada}`)

      setAnunciosMl(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar anúncios sem SKU!')
    } finally {
      setIsNoSkuAnunciosLoading(false)
    }
  }

  async function handleSearchComposicao() {
    setSelectedAnuncio({})

    try {
      setIsLoadingSearchComposicao(true)

      const response = await apinode.get(
        `/anuncios/composicoes/${localStorage.idconta}?search=${searchComposicao}`,
      )

      setAnunciosMl(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as composições!')
    } finally {
      setIsLoadingSearchComposicao(false)
    }
  }

  const buscarDados = async (seller) => {
    setLoading(true)
    try {
      const response = await apinode.get(`/anuncios/${localStorage.idconta}`, {
        params: {
          seller: seller,
        },
      })

      setAnunciosMl(response.data)
      setLoading(false)
    } catch (error) {
      swal('Ops!', 'Erro ao buscar anúncios', 'warning')
      console.error('Ops! Ocorreu um erro:', error)
      setLoading(false)
    }
  }

  useEffect(() => {
    buscarContasMercadoLibre()
  }, [])

  // useEffect(() => {
  //   if (contaSelecionada && conta.length > 0) {
  //     try {
  //       buscarDados(contaSelecionada);
  //     } catch (error) {
  //       console.error("Failed to fetch selected data:", error);
  //     }
  //   }
  // }, []);

  const tipoAnuncio = {
    gold_pro: 'Premium',
    gold_premium: 'Diamante',
    gold_special: 'Clássico',
    gold: 'Ouro',
    silver: 'Prata',
    bronze: 'Bronze',
    free: 'Grátis',
  }

  const handleContaChange = async (e) => {
    const selectedConta = e.target.value

    // Update the selected account state
    setContaSelecionada(selectedConta)
    setContaReplicar(selectedConta)

    // Optionally check if the selected account is valid before fetching data
    if (selectedConta) {
      try {
        // Fetch data based on the newly selected account
        await buscarDados(selectedConta)
      } catch (error) {
        console.error('Error fetching data for the selected account:', error)
      }
    }
  }

  return (
    <>
      <Navbar />
      <div
        className="mt-page"
        style={{ height: '100%', position: 'relative' }}
      >
        {/* HEADER / TOOLBAR */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: 12,
          }}
        >
          <div>
            <h1 style={{ margin: 0, fontSize: 22, lineHeight: 1.2 }}>
              Gestão de Anúncios
            </h1>
            <small style={{ color: '#6c757d' }}>
              Gerencie anúncios, variações e estoque em um só lugar
            </small>
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <CustomButton
              title="Ajustes Em Massa"
              onClick={() => setIsModalAjustesMassaOpen(true)}
            >
              <FaCogs style={{ marginRight: 6 }} />
            </CustomButton>

            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAtivarAnunciosSelecionados}
              disabled={!selectedStatus}
              style={{
                height: 40,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              title="Ativar Anúncios Selecionados"
            >
              <FaStarHalfAlt style={{ marginRight: 6 }} />
              Ativar
            </button>

            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={handlePausarAnunciosSelecionados}
              disabled={!selectedStatus}
              style={{
                height: 40,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              title="Pausar Anúncios Selecionados"
            >
              <FaPause style={{ marginRight: 6 }} />
              Pausar
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary"
              // onClick={handleCriarAnuncios}
              disabled={!selectedStatus}
              style={{
                height: 40,
                display: 'inline-flex',
                alignItems: 'center',
              }}
              title="Criar Anúncios"
            >
              <FaPlus style={{ marginRight: 6 }} />
              Criar
            </button>
          </div>
        </div>

        {/* CARD DE FILTROS PRINCIPAIS */}
        <div
          className="col-md-12"
          style={{
            marginBottom: 16,
            fontSize: 14,
            borderRadius: 8,
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '2fr 1fr 1fr',
              gap: 16,
              alignItems: 'end',
            }}
          >
            {/* Pesquisar anúncios */}
            <div>
              <label
                style={{
                  marginBottom: 6,
                  display: 'block',
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#495057',
                }}
              >
                Pesquisar Anúncios
              </label>
              <div className="input-group">
                <select
                  value={tipo}
                  onChange={(e) => handleTipoChange(e.target.value)}
                  className="form-select"
                  style={{ height: 40, maxWidth: 120 }}
                >
                  <option value="mlb">MLB</option>
                  <option value="title">Título</option>
                  <option value="sku">SKU</option>
                </select>

                <input
                  type="text"
                  placeholder="Pesquisar..."
                  className="form-control"
                  style={{ height: 40 }}
                  value={pesquisa}
                  onChange={(e) => setPesquisa(e.target.value)}
                />

                <CustomButton
                  title="Pesquisar"
                  onClick={buscarDadosPesquisa}
                  style={{ height: 40, minWidth: 110 }}
                >
                  <Search />
                </CustomButton>
              </div>
            </div>

            {/* Conta */}
            <div>
              <label
                style={{
                  marginBottom: 6,
                  display: 'block',
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#495057',
                }}
              >
                Conta
              </label>
              <select
                id="storeDropdown"
                className="form-select"
                value={contaSelecionada}
                onChange={handleContaChange}
                style={{ height: 40 }}
              >
                {sortedConta.map((option) => (
                  <option
                    key={option.ID_CONTA}
                    value={option.ID_CONTA}
                  >
                    {option.APELIDO}
                  </option>
                ))}
              </select>
            </div>

            {/* Status */}
            <div>
              <label
                style={{
                  marginBottom: 6,
                  display: 'block',
                  fontSize: 13,
                  fontWeight: 500,
                  color: '#495057',
                }}
              >
                Status
              </label>
              <CreatableSelect
                isClearable
                value={selectedStatus}
                onChange={handleStatusChange}
                options={statusMap}
                styles={{
                  control: (base) => ({
                    ...base,
                    fontSize: 14,
                    height: 40,
                    minHeight: 40,
                  }),
                }}
              />
            </div>
          </div>
        </div>

        {/* BUSCAS: VARIAÇÃO / COMPOSIÇÃO / SEM SKU */}
        <Row className="mb-4">
          {/* Pesquisar Variação */}
          <Col>
            <Form.Label
              className="mb-1 text-muted"
              style={{ fontSize: 13 }}
            >
              Pesquisar Variação
            </Form.Label>
            <InputGroup>
              <Form.Control
                placeholder="SKU ou ID da Variação"
                value={searchVariacao}
                onChange={(e) => setSearchVariacao(e.target.value)}
                style={{ height: 40 }}
              />
              <CustomButton
                isDisabled={!searchVariacao}
                title="Pesquisar"
                isLoading={isLoadingSearch}
                isLoadingText="Pesquisando..."
                onClick={handleSearchVariacao}
                style={{ height: 40, minWidth: 120 }}
              >
                <Search />
              </CustomButton>
            </InputGroup>
          </Col>

          {/* Pesquisar Composição */}
          <Col>
            <Form.Label
              className="mb-1 text-muted"
              style={{ fontSize: 13 }}
            >
              Pesquisar Composição
            </Form.Label>

            <InputGroup>
              <Form.Control
                placeholder="SKU Composição"
                value={searchComposicao}
                onChange={(e) => setSearchComposicao(e.target.value)}
                style={{ height: 40 }}
              />
              <CustomButton
                isDisabled={!searchComposicao}
                title="Pesquisar"
                isLoading={isLoadingSearchComposicao}
                isLoadingText="Pesquisando..."
                onClick={handleSearchComposicao}
                style={{ height: 40, minWidth: 120 }}
              >
                <Search />
              </CustomButton>
            </InputGroup>
          </Col>

          {/* Botão "sem SKU" */}
          <Col
            style={{
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <CustomButton
              noMargin
              title="Buscar Anúncios sem SKU"
              onClick={buscarAnunciosSemSku}
              isLoading={isNoSkuAnunciosLoading}
              isLoadingText="Buscando..."
              style={{ height: 40 }}
            >
              <Ban />
            </CustomButton>
          </Col>
        </Row>

        <Row className="mb-4">
          <Col>
            <Form.Label
              className="mb-2 text-secondary fw-semibold"
              style={{ fontSize: 14 }}
            >
              Integração em Massa
            </Form.Label>

            <InputGroup>
              <InputGroup.Text
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRight: 'none',
                  borderRadius: '12px 0 0 12px',
                }}
              >
                <Globe
                  size={18}
                  className="text-muted"
                />
              </InputGroup.Text>

              <Form.Select
                disabled={selectedRows.length === 0}
                style={{
                  height: 42,
                  borderRadius: '0 12px 12px 0',
                  borderLeft: 'none',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                }}
                onChange={(e) => {
                  if (e.target.value === 'shopee') handleOpenShopeeMassModal()
                  if (e.target.value === 'magalu') handleOpenMagaluMassModal()
                }}
                defaultValue=""
              >
                <option
                  value=""
                  disabled
                >
                  Selecionar plataforma...
                </option>
                <option value="shopee">🏬 Shopee</option>
                <option value="magalu">🏬 Magalu</option>
              </Form.Select>
            </InputGroup>
          </Col>

          <Col
            style={{
              display: 'flex',
              alignItems: 'flex-end',
            }}
          >
            <CustomButton
              title={`Replicar Anúncios Selecionados (${selectedRows.length})`}
              isDisabled={selectedRows.length === 0}
              onClick={() => setIsModalBatchReplicarOpen(true)}
            >
              <Copy />
            </CustomButton>
          </Col>
        </Row>

        {/* Adicionando Tabs */}
        <div style={{ height: 'auto' }}>
          <Card style={{ height: '100%' }}>
            <CardBody>
              <div
                style={{
                  background:
                    'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: 20,
                  padding: '24px 28px',
                  marginBottom: 24,
                  boxShadow: '0 10px 40px rgba(102, 126, 234, 0.2)',
                  border: '1px solid rgba(255, 255, 255, 0.15)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                {/* Elemento decorativo de fundo */}
                <div
                  style={{
                    position: 'absolute',
                    top: -50,
                    right: -50,
                    width: 200,
                    height: 200,
                    background: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: '50%',
                    zIndex: 0,
                  }}
                />

                <Row
                  className="align-items-end g-4"
                  style={{ position: 'relative', zIndex: 1 }}
                >
                  <Col
                    lg={3}
                    md={4}
                  >
                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          background: 'rgba(255, 255, 255, 0.2)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: 12,
                        }}
                      >
                        <i
                          className="bi bi-funnel"
                          style={{ color: '#fff', fontSize: 16 }}
                        />
                      </div>
                      <span
                        style={{
                          color: '#fff',
                          fontWeight: 700,
                          fontSize: 15,
                          letterSpacing: '0.5px',
                        }}
                      >
                        ORDENAR POR
                      </span>
                    </div>
                    <Form.Select
                      size="sm"
                      value={sortBy}
                      onChange={(e) => setSortBy(e.target.value)}
                      style={{
                        border: 'none',
                        borderRadius: 12,
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(20px)',
                        fontSize: 13.5,
                        fontWeight: 600,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        padding: '10px 14px',
                        color: '#2d3748',
                      }}
                    >
                      <option value="date_desc">🕐 Mais Recentes</option>
                      <option value="sales_desc">🔥 Mais Vendidos</option>
                      <option value="date_asc">📅 Mais Antigos</option>
                      <option value="sales_asc">📉 Menos Vendidos</option>
                      <option value="price_desc">💰 Maior Preço</option>
                      <option value="price_asc">💸 Menor Preço</option>
                      <option value="stock_desc">📦 Maior Estoque</option>
                      <option value="health_desc">💚 Melhor Saúde</option>
                    </Form.Select>
                  </Col>

                  <Col
                    lg={3}
                    md={4}
                  >
                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          background: 'rgba(255, 255, 255, 0.2)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: 12,
                        }}
                      >
                        <i
                          className="bi bi-check-circle"
                          style={{ color: '#fff', fontSize: 16 }}
                        />
                      </div>
                      <span
                        style={{
                          color: '#fff',
                          fontWeight: 700,
                          fontSize: 15,
                          letterSpacing: '0.5px',
                        }}
                      >
                        STATUS
                      </span>
                    </div>
                    <Form.Select
                      size="sm"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      style={{
                        border: 'none',
                        borderRadius: 12,
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(20px)',
                        fontSize: 13.5,
                        fontWeight: 600,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        padding: '10px 14px',
                        color: '#2d3748',
                      }}
                    >
                      <option value="all">Todos</option>
                      <option value="active">✅ Ativos</option>
                      <option value="paused">⏸️ Pausados</option>
                      <option value="paused_with_stock">
                        📦 Pausados com Estoque
                      </option>
                      <option value="paused_no_stock">
                        📭 Pausados sem Estoque
                      </option>
                      <option value="closed">❌ Finalizados</option>
                    </Form.Select>
                  </Col>

                  <Col
                    lg={3}
                    md={4}
                  >
                    <div className="d-flex align-items-center mb-3">
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          background: 'rgba(255, 255, 255, 0.2)',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          marginRight: 12,
                        }}
                      >
                        <i
                          className="bi bi-heart-pulse"
                          style={{ color: '#fff', fontSize: 16 }}
                        />
                      </div>
                      <span
                        style={{
                          color: '#fff',
                          fontWeight: 700,
                          fontSize: 15,
                          letterSpacing: '0.5px',
                        }}
                      >
                        SAÚDE
                      </span>
                    </div>
                    <Form.Select
                      size="sm"
                      value={healthFilter}
                      onChange={(e) => setHealthFilter(e.target.value)}
                      style={{
                        border: 'none',
                        borderRadius: 12,
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(20px)',
                        fontSize: 13.5,
                        fontWeight: 600,
                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                        padding: '10px 14px',
                        color: '#2d3748',
                      }}
                    >
                      <option value="all">Todas</option>
                      <option value="excellent">💚 Excelente (80%+)</option>
                      <option value="good">💛 Boa (60-79%)</option>
                      <option value="average">🧡 Regular (40-59%)</option>
                      <option value="poor">❤️ Ruim (0-39%)</option>
                    </Form.Select>
                  </Col>

                  <Col
                    lg={3}
                    className="text-end"
                  >
                    <div
                      style={{
                        color: 'rgba(255,255,255,0.9)',
                        fontSize: 13,
                        fontWeight: 500,
                        marginBottom: 4,
                      }}
                    >
                      Total de anúncios
                    </div>
                    <div
                      style={{
                        color: '#fff',
                        fontSize: 24,
                        fontWeight: 800,
                        textShadow: '0 2px 4px rgba(0,0,0,0.2)',
                      }}
                    >
                      {getFilteredAndSortedAnuncios().length}
                    </div>
                  </Col>
                </Row>
              </div>
              <Tabs
                defaultActiveKey="anuncios"
                id="tab"
                style={{ backgroundColor: 'transparent', border: 'none' }}
              >
                <Tab
                  eventKey="anuncios"
                  title="Anúncios"
                >
                  <Table
                    responsive
                    hover
                    className="align-middle table-sm table-compact table-clean"
                    style={{
                      backgroundColor: '#fff',
                      borderRadius: 16,
                      overflow: 'hidden',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
                      border: '1px solid rgba(0,0,0,0.02)',
                    }}
                  >
                    <thead
                      style={{
                        background:
                          'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
                        color: '#374151',
                        fontSize: 13.5,
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                      }}
                    >
                      <tr style={{ borderBottom: '2px solid #e2e8f0' }}>
                        <th
                          style={{
                            width: 110,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Imagem
                        </th>
                        <th style={{ minWidth: 360, padding: '16px 12px' }}>
                          Produto
                        </th>
                        <th
                          style={{
                            width: 120,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Status
                        </th>
                        <th
                          style={{
                            width: 110,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Saúde
                        </th>
                        <th
                          style={{
                            width: 140,
                            textAlign: 'right',
                            padding: '16px 12px',
                          }}
                        >
                          Preço
                        </th>
                        <th
                          style={{
                            width: 120,
                            textAlign: 'right',
                            padding: '16px 12px',
                          }}
                        >
                          Estoque
                        </th>
                        <th
                          style={{
                            width: 120,
                            textAlign: 'right',
                            padding: '16px 12px',
                          }}
                        >
                          Vendidos
                        </th>
                        <th
                          style={{
                            width: 140,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Variações
                        </th>
                        <th
                          style={{
                            width: 160,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Atualizado
                        </th>
                        <th
                          style={{
                            width: 260,
                            textAlign: 'center',
                            padding: '16px 12px',
                          }}
                        >
                          Ações
                        </th>
                      </tr>
                    </thead>

                    <tbody style={{ fontSize: 14, color: '#374151' }}>
                      <>
                        {isLoading ||
                        isLoadingSearch ||
                        isLoadingSearchComposicao ||
                        isNoSkuAnunciosLoading ? (
                          <tr>
                            <td
                              colSpan="10"
                              style={{ textAlign: 'center', padding: 40 }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  gap: 16,
                                }}
                              >
                                <Spinner
                                  animation="border"
                                  role="status"
                                  style={{ color: '#667eea' }}
                                >
                                  <span className="visually-hidden">
                                    Carregando...
                                  </span>
                                </Spinner>
                                <span
                                  style={{
                                    color: '#6b7280',
                                    fontSize: 14,
                                    fontWeight: 500,
                                  }}
                                >
                                  Carregando anúncios...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          getFilteredAndSortedAnuncios()
                            .slice(pagesVisited, pagesVisited + anunciosPerPage)
                            .map((anuncio, index) => (
                              <React.Fragment key={anuncio.ID}>
                                <tr
                                  style={{
                                    transition: 'all 0.2s ease',
                                    borderBottom: '1px solid #f1f5f9',
                                  }}
                                >
                                  {/* Imagem com hover effect */}
                                  <td
                                    style={{
                                      textAlign: 'center',
                                      padding: '16px 12px',
                                    }}
                                    className="td-thumb"
                                  >
                                    <div
                                      style={{
                                        width: 64,
                                        height: 64,
                                        borderRadius: 12,
                                        overflow: 'hidden',
                                        margin: '0 auto',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                                        transition:
                                          'transform 0.2s ease, box-shadow 0.2s ease',
                                      }}
                                      onMouseEnter={(e) => {
                                        e.target.style.transform = 'scale(1.05)'
                                        e.target.style.boxShadow =
                                          '0 6px 20px rgba(0,0,0,0.15)'
                                      }}
                                      onMouseLeave={(e) => {
                                        e.target.style.transform = 'scale(1)'
                                        e.target.style.boxShadow =
                                          '0 4px 12px rgba(0,0,0,0.1)'
                                      }}
                                    >
                                      <img
                                        src={anuncio.THUMBNAIL}
                                        alt="Imagem"
                                        style={{
                                          width: '100%',
                                          height: '100%',
                                          objectFit: 'cover',
                                        }}
                                      />
                                    </div>
                                  </td>

                                  {/* Produto com melhor layout */}
                                  <td
                                    style={{
                                      lineHeight: 1.5,
                                      padding: '16px 12px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'space-between',
                                      }}
                                    >
                                      <div style={{ flex: 1 }}>
                                        <strong
                                          style={{
                                            color: '#1f2937',
                                            fontSize: 15,
                                            display: 'block',
                                            marginBottom: 6,
                                            fontWeight: 600,
                                          }}
                                        >
                                          {anuncio.TITLE?.length > 60
                                            ? `${anuncio.TITLE.slice(0, 60)}...`
                                            : anuncio.TITLE}{' '}
                                          <a
                                            href={anuncio.PERMALINK}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{
                                              color: '#667eea',
                                            }}
                                          >
                                            <Link size={25} />
                                          </a>
                                        </strong>
                                        <div
                                          style={{
                                            fontSize: 12,
                                            color: '#6b7280',
                                            background: '#f9fafb',
                                            padding: '4px 8px',
                                            borderRadius: 6,
                                            display: 'inline-block',
                                          }}
                                        >
                                          MLB:{' '}
                                          <a
                                            href={`https://www.mercadolivre.com.br/publicaciones/${anuncio.CODIGOMK}/modificar?callback_url=https://www.mercadolivre.com.br/anuncios/lista?filters=ACTIVE&search=&sort=&page=1`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                              textDecoration: 'none',
                                              color: '#667eea',
                                              fontWeight: 600,
                                            }}
                                          >
                                            {anuncio.CODIGOMK}
                                          </a>
                                          {anuncio.LOGISTIC_TYPE ===
                                            'fulfillment' && (
                                            <i
                                              className="bi bi-lightning"
                                              style={{
                                                color: '#10b981',
                                                marginLeft: 6,
                                              }}
                                              title="Produto full"
                                            />
                                          )}
                                        </div>
                                      </div>

                                      {/* Botão de integração melhorado */}
                                      <Dropdown>
                                        <Dropdown.Toggle
                                          variant="outline-primary"
                                          size="sm"
                                          style={{
                                            padding: '6px 12px',
                                            marginLeft: 12,
                                            borderRadius: 8,
                                            fontSize: 12,
                                            fontWeight: 600,
                                            border: '2px solid #667eea',
                                            background: 'transparent',
                                            color: '#667eea',
                                            transition: 'all 0.2s ease',
                                          }}
                                        >
                                          <FaTruck
                                            size={12}
                                            style={{ marginRight: 6 }}
                                          />
                                          Integrar
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu
                                          style={{
                                            borderRadius: 12,
                                            boxShadow:
                                              '0 8px 24px rgba(0,0,0,0.12)',
                                          }}
                                        >
                                          <Dropdown.Item
                                            onClick={() =>
                                              handleOpenShopeeModal(anuncio)
                                            }
                                          >
                                            <FaTruck className="me-2" /> Shopee
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            disabled
                                            style={{ opacity: 0.5 }}
                                          >
                                            <i className="bi bi-amazon me-2" />{' '}
                                            Amazon
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            onClick={() =>
                                              handleOpenMagaluModal(anuncio)
                                            }
                                          >
                                            <i className="bi bi-shop me-2" />{' '}
                                            Magalu
                                          </Dropdown.Item>
                                          <Dropdown.Item
                                            disabled
                                            style={{ opacity: 0.5 }}
                                          >
                                            <i className="bi bi-building me-2" />{' '}
                                            Leroy Merlin
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </div>
                                  </td>

                                  {/* Status com badges melhorados */}
                                  <td
                                    style={{
                                      textAlign: 'center',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    {anuncio.STATUS === 'active' ? (
                                      <span
                                        className="badge"
                                        style={{
                                          background:
                                            'linear-gradient(135deg, #10b981, #059669)',
                                          color: 'white',
                                          padding: '6px 12px',
                                          borderRadius: 20,
                                          fontSize: 11,
                                          fontWeight: 600,
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.5px',
                                        }}
                                      >
                                        Ativo
                                      </span>
                                    ) : anuncio.STATUS === 'paused' ? (
                                      <span
                                        className="badge"
                                        style={{
                                          background:
                                            'linear-gradient(135deg, #f59e0b, #d97706)',
                                          color: 'white',
                                          padding: '6px 12px',
                                          borderRadius: 20,
                                          fontSize: 11,
                                          fontWeight: 600,
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.5px',
                                        }}
                                      >
                                        Pausado
                                      </span>
                                    ) : (
                                      <span
                                        className="badge"
                                        style={{
                                          background:
                                            'linear-gradient(135deg, #6b7280, #4b5563)',
                                          color: 'white',
                                          padding: '6px 12px',
                                          borderRadius: 20,
                                          fontSize: 11,
                                          fontWeight: 600,
                                          textTransform: 'uppercase',
                                          letterSpacing: '0.5px',
                                        }}
                                      >
                                        {statusMapping[anuncio.STATUS] ||
                                          anuncio.STATUS}
                                      </span>
                                    )}

                                    {!!anuncio.CATALOG_LISTING &&
                                      !!anuncio.CATALOG_PRODUCT_ID && (
                                        <span
                                          className="badge"
                                          style={{
                                            background:
                                              'linear-gradient(135deg, #0671D6, #003F7A)',
                                            color: 'white',
                                            padding: '6px 12px',
                                            borderRadius: 20,
                                            fontSize: 11,
                                            fontWeight: 600,
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                          }}
                                        >
                                          Catálogo
                                        </span>
                                      )}
                                  </td>

                                  {/* Saúde */}
                                  <td
                                    className="td-chart"
                                    style={{ padding: '16px 12px' }}
                                  >
                                    <div className="progressWrap">
                                      <CircularProgressBar
                                        percentage={anuncio.HEALTH * 100}
                                      />
                                    </div>
                                  </td>

                                  {/* Preço com destaque */}
                                  <td
                                    style={{
                                      textAlign: 'right',
                                      padding: '16px 12px',
                                      fontSize: 15,
                                      fontWeight: 700,
                                      color: '#059669',
                                    }}
                                  >
                                    {anuncio.PRICE.toLocaleString('pt-BR', {
                                      style: 'currency',
                                      currency: 'BRL',
                                    })}
                                  </td>

                                  {/* Estoque */}
                                  <td
                                    style={{
                                      textAlign: 'right',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 15,
                                        fontWeight: 600,
                                        color: '#374151',
                                      }}
                                    >
                                      {anuncio.AVAILABLE_QUANTITY}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 11,
                                        color: '#9ca3af',
                                        textTransform: 'uppercase',
                                      }}
                                    >
                                      unidades
                                    </div>
                                  </td>

                                  {/* Vendidos com destaque para números altos */}
                                  <td
                                    style={{
                                      textAlign: 'right',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 15,
                                        fontWeight: 700,
                                        color:
                                          anuncio.SOLD_QUANTITY > 100
                                            ? '#dc2626'
                                            : anuncio.SOLD_QUANTITY > 50
                                              ? '#f59e0b'
                                              : '#374151',
                                      }}
                                    >
                                      {anuncio.SOLD_QUANTITY}
                                    </div>
                                    <div
                                      style={{
                                        fontSize: 11,
                                        color: '#9ca3af',
                                        textTransform: 'uppercase',
                                      }}
                                    >
                                      vendidas
                                    </div>
                                  </td>

                                  {/* Variações */}
                                  <td
                                    style={{
                                      textAlign: 'center',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    {anuncio.VARIACOES > 0 ? (
                                      <span
                                        className="badge"
                                        style={{
                                          background:
                                            'linear-gradient(135deg, #374151, #1f2937)',
                                          color: 'white',
                                          padding: '6px 12px',
                                          borderRadius: 16,
                                          fontSize: 11,
                                          fontWeight: 600,
                                        }}
                                      >
                                        {anuncio.VARIACOES}{' '}
                                        {anuncio.VARIACOES > 1
                                          ? 'variações'
                                          : 'variação'}
                                      </span>
                                    ) : (
                                      <span
                                        style={{
                                          color: '#9ca3af',
                                          fontSize: 12,
                                        }}
                                      >
                                        —
                                      </span>
                                    )}
                                  </td>

                                  {/* Última atualização */}
                                  <td
                                    style={{
                                      textAlign: 'center',
                                      whiteSpace: 'nowrap',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: 13,
                                        fontWeight: 500,
                                        color: '#374151',
                                      }}
                                    >
                                      {new Date(
                                        anuncio.LAST_UPDATED,
                                      ).toLocaleDateString('pt-BR')}
                                    </div>
                                  </td>

                                  {/* Ações com melhor espaçamento */}
                                  <td
                                    style={{
                                      textAlign: 'center',
                                      padding: '16px 12px',
                                    }}
                                  >
                                    <ButtonGroup
                                      aria-label="Ações"
                                      size="sm"
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: 4,
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        style={{
                                          transform: 'scale(1.1)',
                                          marginRight: 12,
                                          accentColor: '#667eea',
                                        }}
                                        checked={selectedRows.includes(
                                          anuncio.CODIGOMK,
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(anuncio.CODIGOMK)
                                        }
                                      />

                                      {anuncio.VARIACOES > 0 && (
                                        <>
                                          {isVariantsLoading[index] ? (
                                            <CustomSpinner
                                              size={18}
                                              style={{ marginRight: 8 }}
                                            />
                                          ) : (
                                            <Button
                                              variant="link"
                                              title="Ver variações"
                                              style={{
                                                color: '#667eea',
                                                padding: '4px 8px',
                                              }}
                                              onClick={() => {
                                                setSelectedVariantsIds([])
                                                setSelectedCodigoMk('')
                                                getVariants(
                                                  anuncio.CODIGOMK,
                                                  index,
                                                )
                                              }}
                                            >
                                              <EyeFill size={16} />
                                            </Button>
                                          )}
                                        </>
                                      )}

                                      <Button
                                        title="Replicar"
                                        variant="link"
                                        style={{
                                          color: '#059669',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() => {
                                          setProdutonome(anuncio.TITLE)
                                          setSelectedCodigoMk(anuncio.CODIGOMK)
                                          setShowModalReplicar(true)
                                        }}
                                      >
                                        <ArrowRepeat size={16} />
                                      </Button>

                                      <Button
                                        title="Editar SKU"
                                        disabled={anuncio.VARIACOES > 0}
                                        variant="link"
                                        style={{
                                          color: '#f59e0b',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() => {
                                          setProdutonome(anuncio.TITLE)
                                          setShowModalSku(true)
                                          setSelectedCodigoMk(anuncio.CODIGOMK)
                                        }}
                                      >
                                        <Pencil size={16} />
                                      </Button>

                                      <Button
                                        variant="link"
                                        title="Ativar"
                                        style={{
                                          color: '#10b981',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() =>
                                          confirmActionAndHandleAnuncio(
                                            'Ativar Anuncio',
                                            'Tem certeza que deseja ativar o anúncio?',
                                            () =>
                                              handleActivedAnuncio(
                                                anuncio.CODIGOMK,
                                                anuncio.SELLER_ID,
                                              ),
                                          )
                                        }
                                      >
                                        <Check2Circle size={16} />
                                      </Button>

                                      <Button
                                        variant="link"
                                        title="Pausar"
                                        style={{
                                          color: '#f59e0b',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() =>
                                          confirmActionAndHandleAnuncio(
                                            'Pausar Anuncio',
                                            'Tem certeza que deseja pausar o anúncio?',
                                            () =>
                                              handlePausedAnuncio(
                                                anuncio.CODIGOMK,
                                                anuncio.SELLER_ID,
                                              ),
                                          )
                                        }
                                      >
                                        <PauseBtnFill size={16} />
                                      </Button>

                                      <Button
                                        variant="link"
                                        title="Alterar Estoque"
                                        style={{
                                          color: '#8b5cf6',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() =>
                                          confirmActionAndOpenModal(
                                            anuncio.CODIGOMK,
                                            anuncio.SELLER_ID,
                                            anuncio.TITLE,
                                          )
                                        }
                                      >
                                        <FaCubes size={16} />
                                      </Button>

                                      <Button
                                        title="Excluir"
                                        variant="link"
                                        disabled={anuncio.STATUS !== 'paused'}
                                        style={{
                                          color: '#dc2626',
                                          padding: '4px 8px',
                                        }}
                                        onClick={() =>
                                          Swal.fire({
                                            title:
                                              'Tem certeza que deseja excluir o anúncio?',
                                            showDenyButton: true,
                                            confirmButtonText: 'Sim',
                                            denyButtonText: `Não`,
                                          }).then((result) => {
                                            if (result.isConfirmed)
                                              excluirAnuncio(anuncio, index)
                                          })
                                        }
                                      >
                                        {isDeleteAnuncioLoading[index] ? (
                                          <CustomSpinner size={16} />
                                        ) : (
                                          <Trash size={16} />
                                        )}
                                      </Button>
                                    </ButtonGroup>
                                  </td>
                                </tr>

                                {/* SUBTABELA DE VARIAÇÕES */}
                                {selectedAnuncio[index] && (
                                  <tr id="tr-table">
                                    <td
                                      colSpan={10}
                                      style={{
                                        background: '#fcfcfd',
                                        padding: 0,
                                      }}
                                    >
                                      <Table
                                        hover
                                        responsive
                                        className="align-middle table-sm variations-table"
                                        style={{
                                          margin: 0,
                                          background: '#fff',
                                        }}
                                      >
                                        <thead
                                          style={{
                                            background: '#fff',
                                            fontSize: 12,
                                            borderBottom: '2px solid #f1f3f5',
                                          }}
                                        >
                                          <tr>
                                            <th
                                              className="td-center"
                                              style={{ width: 80 }}
                                            >
                                              Imagem
                                            </th>
                                            <th
                                              className="td-center"
                                              style={{ width: 90 }}
                                            >
                                              ID
                                            </th>
                                            <th style={{ minWidth: 140 }}>
                                              SKU
                                            </th>
                                            <th>Descrição</th>
                                            <th
                                              className="td-center"
                                              style={{ width: 140 }}
                                            >
                                              GTIN
                                            </th>
                                            <th
                                              className="td-right"
                                              style={{ width: 120 }}
                                            >
                                              Preço
                                            </th>
                                            <th
                                              className="td-right"
                                              style={{ width: 130 }}
                                            >
                                              Vendidos
                                            </th>
                                            <th
                                              className="td-right"
                                              style={{ width: 140 }}
                                            >
                                              Disponível
                                            </th>
                                            <th
                                              className="td-right"
                                              style={{ width: 140 }}
                                            >
                                              Estoque Ziphub
                                            </th>
                                            <th
                                              className="td-center"
                                              style={{ width: 280 }}
                                            >
                                              Ações
                                            </th>
                                            <th
                                              className="td-center"
                                              style={{ width: 60 }}
                                            >
                                              <Form.Check
                                                onChange={(e) => {
                                                  setSelectedCodigoMk(
                                                    anuncio.CODIGOMK,
                                                  )
                                                  if (e.target.checked) {
                                                    setSelectedVariantsIds(
                                                      selectedAnuncio[
                                                        index
                                                      ].map(
                                                        (v) => v.idvariacao,
                                                      ),
                                                    )
                                                  } else {
                                                    setSelectedVariantsIds([])
                                                  }
                                                }}
                                              />
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody style={{ fontSize: 13.5 }}>
                                          {selectedAnuncio[index].map(
                                            (variant, variantIndex) => (
                                              <tr key={variant.idvariacao}>
                                                {/* Imagem da variação */}
                                                <td className="td-center variation-thumb">
                                                  {variant.thumbnail ? (
                                                    <img
                                                      src={variant.thumbnail}
                                                      alt={
                                                        variant.descricao ||
                                                        'Variante'
                                                      }
                                                      style={{
                                                        width: 60,
                                                        height: 60,
                                                        objectFit: 'cover',
                                                        borderRadius: 6,
                                                      }}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        fontSize: 12,
                                                        color: '#aaa',
                                                      }}
                                                    >
                                                      Sem foto
                                                    </span>
                                                  )}
                                                </td>

                                                <td className="td-center">
                                                  {variant.idvariacao}
                                                </td>
                                                <td>
                                                  {variant.skuvariacao &&
                                                  variant.skuvariacao !== 'null'
                                                    ? variant.skuvariacao
                                                    : 'N/I'}
                                                </td>
                                                <td>
                                                  {variant.descricao || 'N/I'}
                                                </td>
                                                <td className="td-center">
                                                  {variant.gtin &&
                                                  variant.gtin !== 'null'
                                                    ? variant.gtin
                                                    : 'N/I'}
                                                </td>
                                                <td className="td-right">
                                                  {variant.price
                                                    ? formatPrice(variant.price)
                                                    : 'N/I'}
                                                </td>
                                                <td className="td-right">
                                                  {variant.sold_quantity ||
                                                    'N/I'}
                                                </td>
                                                <td className="td-right">
                                                  {variant.available_quantity ||
                                                    'N/I'}
                                                </td>
                                                <td className="td-right">
                                                  {variant.estoque ||
                                                    'Sem Estoque'}
                                                </td>

                                                <td className="td-center">
                                                  <div
                                                    style={{
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          Pausar Variante
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Button
                                                        variant="link"
                                                        disabled={
                                                          !variant.skuvariacao ||
                                                          variant.skuvariacao ===
                                                            'null' ||
                                                          isPausedLoading[
                                                            variantIndex
                                                          ] ||
                                                          variant.available_quantity ===
                                                            0
                                                        }
                                                        onClick={() =>
                                                          handlePauseVariantQuantity(
                                                            variant.mlb_anuncio,
                                                            variant.idvariacao,
                                                            variantIndex,
                                                          )
                                                        }
                                                      >
                                                        {isPausedLoading[
                                                          variantIndex
                                                        ] ? (
                                                          <CustomSpinner
                                                            size={18}
                                                          />
                                                        ) : (
                                                          <FaPause
                                                            style={{
                                                              marginRight: 6,
                                                            }}
                                                          />
                                                        )}
                                                      </Button>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          Editar SKU
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Button
                                                        variant="link"
                                                        onClick={() => {
                                                          setProdutonome(
                                                            variant.descricao,
                                                          )
                                                          setShowModalSkuVariant(
                                                            true,
                                                          )
                                                          setSelectedCodigoMk(
                                                            anuncio.CODIGOMK,
                                                          )
                                                          setSelectedIdVariacao(
                                                            variant.idvariacao,
                                                          )
                                                        }}
                                                      >
                                                        <Pencil size={18} />
                                                      </Button>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          Editar Preço
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Button
                                                        variant="link"
                                                        onClick={() => {
                                                          setProdutonome(
                                                            variant.descricao,
                                                          )
                                                          setSelectedCodigoMk(
                                                            anuncio.CODIGOMK,
                                                          )
                                                          setSelectedIdVariacao(
                                                            variant.idvariacao,
                                                          )
                                                          setShowModalPrice(
                                                            true,
                                                          )
                                                        }}
                                                      >
                                                        <Money size={18} />
                                                      </Button>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          Alterar Estoque
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Button
                                                        variant="link"
                                                        onClick={() =>
                                                          openModalVariant(
                                                            variant.mlb_anuncio,
                                                            anuncio.SELLER_ID,
                                                            variant.descricao,
                                                            variant.idvariacao,
                                                          )
                                                        }
                                                      >
                                                        <FaCubes size={18} />
                                                      </Button>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger
                                                      overlay={
                                                        <Tooltip>
                                                          Gerar EAN
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <Button
                                                        variant="link"
                                                        onClick={() => {
                                                          handleConfirmGenerateEAN(
                                                            anuncio.CODIGOMK,
                                                            variant.idvariacao,
                                                            variantIndex,
                                                          )
                                                        }}
                                                      >
                                                        {isGenerateEANLoding[
                                                          variantIndex
                                                        ] ? (
                                                          <CustomSpinner
                                                            size={18}
                                                          />
                                                        ) : (
                                                          <ArrowRepeat
                                                            size={18}
                                                          />
                                                        )}
                                                      </Button>
                                                    </OverlayTrigger>
                                                  </div>
                                                </td>

                                                <td className="td-center">
                                                  <Form.Check
                                                    checked={selectedVariantsIds.includes(
                                                      variant.idvariacao,
                                                    )}
                                                    onChange={(e) => {
                                                      setSelectedCodigoMk(
                                                        anuncio.CODIGOMK,
                                                      )
                                                      if (e.target.checked) {
                                                        setSelectedVariantsIds(
                                                          (prev) => [
                                                            ...prev,
                                                            variant.idvariacao,
                                                          ],
                                                        )
                                                      } else {
                                                        setSelectedVariantsIds(
                                                          (prev) =>
                                                            prev.filter(
                                                              (id) =>
                                                                id !==
                                                                variant.idvariacao,
                                                            ),
                                                        )
                                                      }
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </Table>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))
                        )}
                      </>
                    </tbody>
                  </Table>

                  {!isLoading && (
                    <ReactPaginate
                      previousLabel={'Anterior'}
                      nextLabel={'Próxima'}
                      pageCount={pageCount}
                      onPageChange={changePage}
                      containerClassName={'pagination'}
                      previousLinkClassName={
                        'pagination__link custom-previous-class'
                      } // Adicione classes personalizadas para o botão Anterior
                      nextLinkClassName={'pagination__link custom-next-class'} // Adicione classes personalizadas para o botão Próxima
                      disabledClassName={'pagination__link--disabled'}
                      activeClassName={'pagination__link--active'}
                    />
                  )}
                </Tab>

                {/* <Tab
                  eventKey="configuracoes"
                  title="Configurações"
                >

                </Tab> */}
              </Tabs>
            </CardBody>
          </Card>
        </div>

        {selectedVariantsIds.length > 0 && (
          <CustomButton
            isLoading={isSelectedVariantsLoading}
            isLoadingText="Pausando..."
            title="Pausar Variantes Selecionadas"
            styles={{
              position: 'fixed',
              bottom: 0,
              right: 0,
              margin: 10,
            }}
            onClick={handlePauseSelectedVariants}
          >
            <Pause size={25} />
          </CustomButton>
        )}
      </div>

      {/* MODAL AJUSTES EM MASSA */}
      {isModalAjustesMassaOpen && (
        <Modal
          show={isModalAjustesMassaOpen}
          onHide={() => setIsModalAjustesMassaOpen(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Ajustes Em Massa</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col>
                <Form.Label>SKU</Form.Label>
                <Form.Control
                  value={ajustesMassa.sku}
                  onChange={(e) =>
                    setAjustesMassa((prevState) => ({
                      ...prevState,
                      sku: e.target.value,
                    }))
                  }
                />
              </Col>

              <Col>
                <OverlayTrigger
                  overlay={<Tooltip>Para pausar digite 0</Tooltip>}
                >
                  <Form.Label>
                    Quantidade <FaInfoCircle />
                  </Form.Label>
                </OverlayTrigger>
                <Form.Control
                  value={ajustesMassa.quantidade}
                  onChange={(e) =>
                    setAjustesMassa((prevState) => ({
                      ...prevState,
                      quantidade: e.target.value,
                    }))
                  }
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Alert variant="warning">
                  Esse processo pode demorar, uma vez iniciado ele não pode ser
                  cancelado ou desfeito, tenha certeza antes de continuar.
                </Alert>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <CustomButton
              title="Ajustar"
              isDisabled={!ajustesMassa.sku || !ajustesMassa.quantidade}
              onClick={handleMassiveAdjust}
              isLoading={isMassiveAdjustLoading}
              isLoadingText="Ajustando..."
            >
              <FaWrench />
            </CustomButton>
          </Modal.Footer>
        </Modal>
      )}

      <Modal
        show={showModal}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>{produtoNome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <InputGroup.Text>Novo Estoque</InputGroup.Text>
            <FormControl
              type="number"
              value={newStock}
              onChange={(e) => setNewStock(e.target.value)}
            />
          </InputGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
          >
            Fechar
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalVariante}
        onShow={() => setNewStockVariante('')}
        onHide={() => setShowModalVariante(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: 20,
            }}
          >
            {produtoNome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomIntegerInput
            placeholder="Novo Estoque"
            value={newStockVariante}
            onChange={(e) => setNewStockVariante(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalVariante(false)}
          >
            Fechar
          </Button>
          <CustomButton
            onClick={handleConfirmVariant}
            isLoading={isQuantityVariantLoading}
            isLoadingText="Confirmando..."
          >
            Confirmar
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {/* MODAL EDITAR SKU */}
      <Modal
        show={showModalSku}
        onShow={() => setAnuncioSku('')}
        onHide={() => setShowModalSku(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: 20,
            }}
          >
            {produtoNome}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            placeholder="SKU"
            value={anuncioSku}
            onChange={(e) => setAnuncioSku(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalSku(false)}
          >
            Fechar
          </Button>
          <CustomButton
            onClick={handleConfirmSKUAnuncio}
            isLoading={isSkuAnuncioLoading}
            isLoadingText="Confirmando..."
          >
            Confirmar
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {/* MODAL REPLICAR ANÚNCIO */}
      {showModalReplicar && (
        <Modal
          show={showModalReplicar}
          onHide={() => setShowModalReplicar(false)}
          centered
        >
          <Modal.Header>
            <Modal.Title
              style={{
                fontSize: 16,
              }}
            >
              Selecione as contas para replicar <strong>{produtoNome}</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              isMulti
              value={accounts}
              onChange={(values) => setAccounts(values)}
              name="accounts"
              options={accountsOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Selecione as contas"
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowModalReplicar(false)}
            >
              Fechar
            </Button>
            <CustomButton
              onClick={handleReplicarAnuncio}
              isLoading={isReplicarAnuncioLoading}
              isLoadingText="Replicando..."
              isDisabled={accounts.length === 0}
            >
              Replicar
            </CustomButton>
          </Modal.Footer>
        </Modal>
      )}

      {isModalBatchReplicarOpen && (
        <Modal
          show={isModalBatchReplicarOpen}
          onHide={() => setIsModalBatchReplicarOpen(false)}
          centered
        >
          <Modal.Header>
            <Modal.Title
              style={{
                fontSize: 16,
              }}
            >
              Selecione as contas para replicar os anúncios
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              isMulti
              value={accounts}
              onChange={(values) => setAccounts(values)}
              name="accounts"
              options={accountsOptions}
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder="Selecione as contas"
            />
          </Modal.Body>
          <Modal.Footer>
            <CustomButton
              title="Fechar"
              onClick={() => setIsModalBatchReplicarOpen(false)}
              secondary
            />

            <CustomButton
              title="Replicar"
              onClick={handleReplicarAnuncioBatch}
              isLoading={isReplicarAnuncioBatchLoading}
              isLoadingText="Replicando..."
              isDisabled={accounts.length === 0}
            >
              <Copy />
            </CustomButton>
          </Modal.Footer>
        </Modal>
      )}

      {/* MODAL EDITAR PREÇO */}
      <Modal
        show={showModalPrice}
        onShow={() => setVariantPrice('')}
        onHide={() => setShowModalPrice(false)}
      >
        <Modal.Header
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Modal.Title
            style={{
              fontSize: 14,
            }}
          >
            {produtoNome}
          </Modal.Title>

          <Alert variant="warning">
            A API do Mercado Livre não permite variações com preços diferentes,
            tenha em mente que ao alterar o preço de uma variação, as outras
            também serão alteradas!
          </Alert>
        </Modal.Header>
        <Modal.Body>
          <CustomPriceInput
            placeholder="Preço"
            value={variantPrice}
            onChange={(e) => setVariantPrice(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalPrice(false)}
          >
            Fechar
          </Button>

          <CustomButton
            onClick={handleConfirmVariantPrice}
            isLoading={isVariantPriceLoading}
            isLoadingText="Confirmando..."
          >
            Confirmar
          </CustomButton>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalSkuVariant}
        onShow={() => setAnuncioSkuVariant('')}
        onHide={() => setShowModalSkuVariant(false)}
        dialogClassName="custom-modalzpl"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 20 }}>{produtoNome}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <Form.Control
              placeholder="Pesquisar SKU"
              value={anuncioSkuVariant}
              onChange={(e) => setAnuncioSkuVariant(e.target.value)}
            />
            <Button
              variant="primary"
              onClick={handleSearchChangeVariant}
              className="ms-2"
            >
              Pesquisar
            </Button>
          </div>
          {isSkuVarianteLoading && <p>Carregando...</p>}
          {!isSkuVarianteLoading && filteredVariantes.length > 0 && (
            <Table
              hover
              size="sm"
              className="mt-3 modern-table"
            >
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Nome</th>
                  <th>Estoque</th>
                </tr>
              </thead>
              <tbody>
                {filteredVariantes.map((variant) => (
                  <tr
                    key={variant.CODPROD}
                    onClick={() => handleSelectVariant(variant.SKU)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{variant.SKU}</td>
                    <td>{variant.DESCRICAO}</td>
                    <td>{variant.QTESTGER}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowModalSkuVariant(false)}
          >
            Fechar
          </Button>
          <CustomButton
            onClick={handleConfirmSKUVariante}
            isLoading={isSkuVarianteLoading}
            isLoadingText="Confirmando..."
          >
            Confirmar
          </CustomButton>
        </Modal.Footer>
      </Modal>

      {/* MODAL SHOPEE INTEGRATION */}
      <Modal
        show={showModalShopee}
        onHide={() => {
          setShowModalShopee(false)
          setIsMassIntegration(false) // reseta quando fechar
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18 }}>
            <FaTruck style={{ marginRight: 8, color: '#ff6b35' }} />
            Integrar com Shopee
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Se for integração em massa */}
          {isMassIntegration ? (
            <Alert
              variant="primary"
              className="mb-4"
            >
              Você selecionou <strong>{selectedMassAnuncios.length}</strong>{' '}
              anúncios para integrar em massa.
            </Alert>
          ) : (
            /* Caso contrário, mostra apenas o anúncio único */
            selectedAnuncioForShopee && (
              <div className="mb-4">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 16,
                  }}
                >
                  <img
                    src={selectedAnuncioForShopee.THUMBNAIL}
                    alt="Produto"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: 'cover',
                      borderRadius: 8,
                      marginRight: 16,
                    }}
                  />
                  <div>
                    <h6 style={{ margin: 0, marginBottom: 4 }}>
                      {selectedAnuncioForShopee.TITLE}
                    </h6>
                    <small style={{ color: '#6c757d' }}>
                      MLB: {selectedAnuncioForShopee.CODIGOMK} | Preço:{' '}
                      {selectedAnuncioForShopee.PRICE?.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </small>
                  </div>
                </div>
                <hr />
              </div>
            )
          )}

          {/* Select de conta Shopee */}
          <div>
            <Form.Label className="mb-2">
              <strong>Selecione a conta da Shopee:</strong>
            </Form.Label>

            {isLoadingShopeeContas ? (
              <div className="text-center py-4">
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Carregando contas da Shopee...
              </div>
            ) : contasShopee.length > 0 ? (
              <Form.Select
                value={contaShopeeSelected}
                onChange={(e) => setContaShopeeSelected(e.target.value)}
                className="mb-3"
              >
                {contasShopee.map((conta) => (
                  <option
                    key={conta.ID_CONTA || conta.id}
                    value={conta.ID_CONTA || conta.id}
                  >
                    {conta.NOME ||
                      conta.nome ||
                      conta.APELIDO ||
                      conta.apelido ||
                      `Conta ${conta.ID_CONTA || conta.id}`}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Alert variant="warning">
                <FaExclamationCircle className="me-2" />
                Nenhuma conta da Shopee encontrada. Verifique se há contas
                configuradas.
              </Alert>
            )}
          </div>

          {contasShopee.length > 0 && (
            <Alert variant="info">
              <strong>Informação:</strong>{' '}
              {isMassIntegration
                ? `Os ${selectedMassAnuncios.length} anúncios selecionados serão integrados com a conta da Shopee.`
                : 'Este produto será integrado com a conta selecionada da Shopee.'}
            </Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalShopee(false)
              setIsMassIntegration(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleIntegrateWithShopee}
            disabled={
              isLoadingEnvio ||
              !contaShopeeSelected ||
              contasShopee.length === 0
            }
            style={{ backgroundColor: '#ff6b35', borderColor: '#ff6b35' }}
          >
            {isLoadingEnvio ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Integrando...
              </>
            ) : (
              <>
                <FaTruck className="me-2" />
                {isMassIntegration
                  ? 'Integrar Anúncios'
                  : 'Integrar com Shopee'}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showModalMagalu}
        onHide={() => {
          setShowModalMagalu(false)
          setIsMassIntegration(false) // reseta ao fechar
        }}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 18 }}>
            <i
              className="bi bi-shop"
              style={{ marginRight: 8, color: '#0066cc' }}
            />
            Integrar com Magalu
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Se for integração em massa */}
          {isMassIntegration ? (
            <Alert
              variant="primary"
              className="mb-4"
            >
              Você selecionou <strong>{selectedMassAnuncios.length}</strong>{' '}
              anúncios para integrar em massa.
            </Alert>
          ) : (
            /* Caso contrário, mostra apenas o anúncio único */
            selectedAnuncioForMagalu && (
              <div className="mb-4">
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: 16,
                  }}
                >
                  <img
                    src={selectedAnuncioForMagalu.THUMBNAIL}
                    alt="Produto"
                    style={{
                      width: 80,
                      height: 80,
                      objectFit: 'cover',
                      borderRadius: 8,
                      marginRight: 16,
                    }}
                  />
                  <div>
                    <h6 style={{ margin: 0, marginBottom: 4 }}>
                      {selectedAnuncioForMagalu.TITLE}
                    </h6>
                    <small style={{ color: '#6c757d' }}>
                      MLB: {selectedAnuncioForMagalu.CODIGOMK} | Preço:{' '}
                      {selectedAnuncioForMagalu.PRICE?.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </small>
                  </div>
                </div>
                <hr />
              </div>
            )
          )}

          {/* Select de conta Magalu */}
          <div>
            <Form.Label className="mb-2">
              <strong>Selecione a conta do Magalu:</strong>
            </Form.Label>

            {isLoadingMagaluContas ? (
              <div className="text-center py-4">
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                />
                Carregando contas do Magalu...
              </div>
            ) : contasMagalu.length > 0 ? (
              <Form.Select
                value={contaMagaluSelected}
                onChange={(e) => setContaMagaluSelected(e.target.value)}
                className="mb-3"
              >
                {contasMagalu.map((conta) => (
                  <option
                    key={conta.ID_CONTA || conta.id}
                    value={conta.ID_CONTA || conta.id}
                  >
                    {conta.NOME ||
                      conta.nome ||
                      conta.APELIDO ||
                      conta.apelido ||
                      `Conta ${conta.ID_CONTA || conta.id}`}
                  </option>
                ))}
              </Form.Select>
            ) : (
              <Alert variant="warning">
                <FaExclamationCircle className="me-2" />
                Nenhuma conta do Magalu encontrada. Verifique se há contas
                configuradas.
              </Alert>
            )}
          </div>

          {contasMagalu.length > 0 && (
            <Alert variant="info">
              <strong>Informação:</strong>{' '}
              {isMassIntegration
                ? `Os ${selectedMassAnuncios.length} anúncios selecionados serão integrados com a conta do Magalu.`
                : 'Este produto será integrado com a conta selecionada do Magalu.'}
            </Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowModalMagalu(false)
              setIsMassIntegration(false)
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleIntegrateWithMagalu}
            disabled={
              isLoadingEnvioMagalu ||
              !contaMagaluSelected ||
              contasMagalu.length === 0
            }
            style={{ backgroundColor: '#0066cc', borderColor: '#0066cc' }}
          >
            {isLoadingEnvioMagalu ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Integrando...
              </>
            ) : (
              <>
                <i className="bi bi-shop me-2" />
                {isMassIntegration
                  ? 'Integrar Anúncios'
                  : 'Integrar com Magalu'}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <IntegrationResultModal
        show={showResultModal}
        onClose={() => setShowResultModal(false)}
        successCount={integrationResult?.successCount}
        failCount={integrationResult?.failCount}
        failedItems={integrationResult?.failedItems}
        platform={integrationResult?.platform}
      />

      {isModalResultadosMassaOpen && (
        <ModalResultadosMassa
          show={isModalResultadosMassaOpen}
          onClose={() => setIsModalResultadosMassaOpen(false)}
          successCount={resultadosAJusteEmMassa?.successCount}
          failCount={resultadosAJusteEmMassa?.failCount}
          failedItems={resultadosAJusteEmMassa?.failedItems}
        />
      )}

      {isModalReplicarResultsOpen && (
        <ModalReplicarResults
          isOpen={isModalReplicarResultsOpen}
          onClose={() => setIsModalReplicarResultsOpen(false)}
          results={replicarResults}
        />
      )}

      {isModalReplicarResultsBatchOpen && (
        <ModalReplicarResultsBatch
          isOpen={isModalReplicarResultsBatchOpen}
          onClose={() => setIsModalReplicarResultsBatchOpen(false)}
          results={replicarResultsBatch}
        />
      )}
    </>
  )
}

const statusMap = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
  { value: 'paused', label: 'Pausado' },
  { value: 'under_review', label: 'Em revisão' },
  { value: 'stopped', label: 'Parado' },
  // Adicione mais estados conforme necessário
]

export default Anuncios
